export const IT = {
  preparing_zip: "Preparazione dello zip…",
  compressing: "Compressione…",
  info_icon: "Una volta contrassegnato come completato, nessun membro aggiuntivo può unirsi o essere aggiunto, e tutti i gruppi di chat saranno disattivati. Si prega di notare che il progetto, insieme a tutti i gruppi di chat e i dati, rimarrà accessibile in uno stato disattivato.",
  mark_is_done: "Sei sicuro di voler contrassegnare il progetto come completato? Una volta contrassegnato, nessun membro aggiuntivo può unirsi o essere aggiunto, e tutti i gruppi di chat saranno disattivati. Si prega di notare che il progetto, insieme a tutti i gruppi di chat e i dati, rimarrà accessibile in uno stato disattivato.",
  mark_not_done: "Sei sicuro di voler riaprire il progetto? Una volta contrassegnato come aperto, i membri aggiuntivi possono unirsi o essere aggiunti, e tutti i gruppi di chat saranno riattivati.",
  mark_as_completed: "Contrassegna progetto come completato",
  room_completed: "Progetto completato",
  room_members: "Membri del progetto",
  deactivated_rooms: "Progetti disattivati",
  deactivated_chats: "Chat disattivate",
  completed_rooms: "Progetti completati",
  request_to_join_a_room: "Richiesta di unirsi al progetto",
  wants_to_rejoin_room: "Username vuole rientrare nel progetto Roomname.",
  invited_you_to_join_room: "Username ti ha invitato a unirti al progetto Roomname.",
  restart: "Riavvia",
  update_text: "È disponibile un nuovo aggiornamento. Clicca su riavvia per installare l'aggiornamento.",
  update_availble: "Aggiornamento disponibile",
  Loading: "Caricamento...",
  logout: "Disconnetti",
  back: "Indietro",
  company_list: "Elenco aziende",
  followers: "Seguaci",
  followings: "Seguiti",
  article: "Articolo",
  companies: "Aziende",
  one_to_one_chat: "Chat individuale",
  profile: "Profilo",
  company: "Azienda",
  company_selection: "Selezione azienda",
  home: "Home",
  contact: "Contatto",
  add_company: "Aggiungi azienda",
  add_project: "Aggiungi progetto",
  capacities: "Capacità",
  work_area: "Area di lavoro",
  company_services: "Servizi aziendali",
  website: "Sito web",
  search_contacts: "Cerca contatti",
  add_or_join_a_company: "Aggiungi o unisciti a un'azienda",
  follow: "Segui",
  following: "Seguendo",
  like: "Mi piace",
  company_contacts: "Contatto aziendale",
  leave_the_company: "Lascia l'azienda",
  news: "Notizie",
  earlier: "Prima",
  action: "Azione",
  another_action: "Altra azione",
  something_else: "Qualcos'altro",
  search: "Cerca",
  search_rooms: "Cerca progetti",
  search_articles: "Cerca articoli",
  contacts: "Contatti",
  suggestions: "Suggerimenti",
  project_list: "Elenco progetti",
  search_results: "Risultati di ricerca",
  add_or_join_project: "Aggiungi o unisciti a un progetto",
  details: "Dettagli",
  your_position_within_company: "Scegli la tua posizione all'interno dell'azienda.",
  close_modal: "Chiudi",
  map: "Mappa",
  or: "O",
  name: "Nome*",
  street: "Via*",
  house_number: "N°",
  postal_code: "CAP",
  city: "Città*",
  opened_by: "Aperto da:",
  project_No: "N° progetto: ",
  building_type: "Tipo di edificio*",
  building_types: "Tipo di edificio",
  add_join: "Aggiungi/Unisciti",
  mandatory_fiels: "*campi obbligatori",
  invalid_fiels: "Questo campo è obbligatorio",
  add_or_join_company: "Aggiungi o unisciti a un'azienda",
  name_of_the_company: "Nome dell'azienda",
  edit_company_details: "Modifica dettagli azienda",
  branch_of_the_building_industry: "Settore dell'industria edile",
  corporate_form: "Forma giuridica",
  position_within_company: "Posizione all'interno dell'azienda",
  request_confirmation: "Richieste progetto in sospeso",
  company_e_mail: "E-mail aziendale",
  type_of_filter: "Digita per filtrare...",
  setting: "Impostazione",
  dashboard: "Dashboard",
  settings: "Impostazioni",
  views: "Visualizzazioni",
  times_seen: "volte visto",
  see_more: "...altro",
  see_less: "...meno",
  in_search: "in ricerca",
  reset_password: "Reimposta password",
  submit: "Invia",
  password: "Password",
  email: "E-mail",
  confirm_password: "Conferma password",
  reset_email: "Reimposta e-mail",
  update: "Aggiorna",
  new_email: "Nuova e-mail",
  kjuup_message: "Messaggio Kjuup",
  delete_profile: "Eliminare il profilo?",
  my_position: "La mia posizione:",
  add: "aggiungi",
  owner_company_admin: "Admin aziendale:",
  owner_company_admin_new: "Admin aziendale",
  mutual_contact: "contatto comune",
  mutual_contacts: "contatti comuni",
  co_owner: "Comproprietario",
  managing_director: "Direttore generale",
  associate: "Socio",
  secretary: "Segretario",
  employee: "Dipendente",
  project_manage: "Project Manager",
  auto_chat_translation: "Traduzione automatica chat",
  translate_room_group_names: "Traduci i nomi dei gruppi chat",
  translate_room_group_names_info: "Se attivato, i nomi dei gruppi chat vengono tradotti automaticamente nella lingua dell'interfaccia.",
  default_view_email: "Vista predefinita: E-Mail",
  default_view_email_info: "Quando attivato, la scheda E-Mail si aprirà per impostazione predefinita invece di Messaggi all'apertura dell'app.",
  integrate_email_in_messages: "Integrate E-Mail in Messages",
  integrate_email_in_messages_info: "When enabled, emails from all connected accounts will appear alongside your chat messages, sorted by date.",
  language: "Lingua",
  english: "Inglese",
  german: "Tedesco",
  french: "Francese",
  italian: "Italiano",
  change_language: "Cambia lingua",
  my_companies: "Le mie aziende",
  employees: "Dipendenti",
  invite_with_a: "Invita su Kjuup",
  add_member: "Aggiungi membro",
  add_user: "Aggiungi utente",
  send_location: "Invia posizione",
  assign_admin_rights: "Modifica diritti admin",
  deactivate_company: "Disattiva azienda",
  remove_employees: "Rimuovi dipendenti",
  remove_members: "Rimuovi membri",
  no_user_found: "Nessun utente trovato!",
  approve: "Approva!",
  deselect_all: "Deseleziona tutto",
  select_all: "Seleziona tutto",
  translation_on_building_projects: "Traduzione nei progetti",
  reported_capacities: "Servizi segnalati",
  up_to_50m_exact: "Fino a 50m esatti",
  company_details_service: "Servizi aziendali",
  company_contact: "Contatto aziendale",
  invite_with_link: "Invita su Kjuup",
  share_link: "Condividi link",
  share_company_link: "Condividi link",
  qr_code: "Codice QR",
  copy_link: "Copia link",
  cancel_link: "Annulla link",
  who_has_confirmed_services: "Chi ha confermato i tuoi servizi?",
  projectss: "Progetti",
  add_services: "Aggiungi servizi",
  services: "Servizi",
  save_text: "Salva",
  share_on: "Condividi su:",
  articlen: "Articolo",
  invite_user_to_confirm_service: "Invita gli utenti a confermare i servizi dell'azienda.",
  link_copied: "Link copiato!",
  email_copied: "E-mail copiata!",
  personal_article: "Articolo personale",
  company_article: "Articolo aziendale",
  characters_remaining: "Caratteri rimanenti",
  optional_information: "Informazioni opzionali",
  project: "Progetto",
  projects: "Progetti...",
  abort: "Annulla",
  preview: "Anteprima",
  post: "Pubblica",
  of: "di",
  remove: "Rimuovi",
  free_capacity: "Portale lavoro",
  current_status_overview: "Panoramica stato attuale",
  report_capacities: "Segnala servizi",
  report_text: "Segnala",
  search_capacities: "Trova appaltatori",
  add_project_user: "Aggiungi utente al progetto",
  media: "Media",
  links: "Link",
  docs: "Docs",
  featured_products: "Prodotti in evidenza...",
  title: "Titolo",
  text: "Testo",
  feed_details: "Dettagli feed",
  add_employee: "Aggiungi dipendente",
  latest: "Recente",
  my_projects: "I miei progetti",
  cancel: "Annulla",
  continue: "Continua",
  role_in_the_building_industry: "Ruolo nell'industria edile",
  als: "come",
  join: "unisciti",
  find: "Trova",
  request_to_join_a_company: "Richiesta di unirsi all'azienda",
  wants_to_join_the_company: "vuole unirsi all'azienda",
  filter_by: "Filtra per",
  ok: "Ok",
  close: "Chiudi",
  weekly_statistics: "Statistiche settimanali",
  is_following_you: "ti sta seguendo.",
  as: "come",
  has_joined_the: "si è unito all'azienda",
  has_looked_at_your_profile: "ha visualizzato il tuo profilo.",
  time: "Ora",
  in_searches_in_past_week: "nelle ricerche la scorsa settimana.",
  has_liked_your_article: "ha messo mi piace al tuo articolo.",
  has_published_a_new_article: "ha pubblicato un nuovo articolo.",
  you: "Tu",
  all_views: "Tutte le visualizzazioni",
  all_profile_views: "Tutte le visualizzazioni del profilo",
  mutual_company: "azienda comune",
  artical_text: "Scrivi articolo...",
  you_have_appeared: "Sei apparso",
  your_request_at_the_company: "La tua richiesta all'azienda",
  times_you_have_appeared_in_searches: "volte sei apparso nelle ricerche",
  appear_more_often_in_searches: "Appari più spesso nelle ricerche",
  you_have_been_found: "Sei stato trovato",
  improve_profile: "Migliora profilo",
  choose_existing_contact_for_single_chat: "Scegli un contatto esistente per chat singola:",
  in_order_to_add_new_contacts: "Per aggiungere nuovi contatti, cerca nuovi contatti nella pagina del profilo.",
  times_in_searches_in_the_last_week: "volte nelle ricerche nell'ultima settimana. Aggiorna il tuo profilo e aggiungi ulteriori dettagli per essere trovato più facilmente.",
  has_been_confirmed: "è stato confermato.",
  have_joined_the: "si sono uniti al",
  building_project: "progetto di costruzione.",
  select_with_which_company_you_want_to_connect_to_the_project: "Seleziona l'azienda che rappresenterai. Questo verrà mostrato agli altri partecipanti.",
  select_with_which_company_you_want_to_connect_to_the_chat: "Seleziona l'azienda che rappresenterai. Questo verrà mostrato agli altri partecipanti.",
  select_internal_section: "Seleziona la sezione interna",
  select_profile_image: "Seleziona immagine profilo",
  share_user: "Condividi utente",
  contact_sender_message: "Condividi questo link per invitare un non membro di Kjuup su Kjuup. Questo link può essere utilizzato da più persone per registrarsi.",
  project_sender_message: "Condividi questo link per invitare un non membro di Kjuup al progetto. Questo link può essere utilizzato da più persone per registrarsi e unirsi al progetto in Kjuup.",
  company_sender_message: "Condividi questo link per invitare un non membro di Kjuup all'azienda. Questo link può essere utilizzato da più persone per registrarsi e unirsi all'azienda in Kjuup.",
  contact_receivers_message: "Link di invito per unirsi a Kjuup. Clicca sul link per registrarti a Kjuup.",
  iphone: "iPhone:",
  iphone_recivers_message: "Se installi Kjuup tramite Apple App Store, devi cliccare su questo link dopo il download per poterti registrare.",
  project_receivers_message: "Link di invito per unirsi al progetto in Kjuup. Clicca sul link per registrarti a Kjuup e unirti al progetto.",
  company_receivers_message: "Link di invito all'azienda in Kjuup. Clicca sul link per registrarti a Kjuup e unirti all'azienda.",
  sign_in: "Accedi",
  enter_your_email_add: "Inserisci il tuo indirizzo e-mail",
  forgot_password: "Password dimenticata",
  dont_have_account: "Non hai un account?",
  register: "Registrati",
  get_app: "Ottieni l'app",
  registration: "Registrazione",
  dep_ing: "Dipl.-Ing.",
  dr: "Dr.",
  dr_ing: "Dr.-Ing.",
  dep_ing_arc: "Dipl.-Ing. Architetto",
  prof: "Prof.",
  first_name: "Nome",
  last_name: "Cognome",
  have_an_account: "Hai un account?",
  when_register_you_agree: "Registrandoti accetti i nostri",
  term_of_use: "termini di utilizzo",
  to: "a",
  in_our: "Nelle nostre",
  data_policy: "politiche sui dati",
  they_find_out: "scoprirai,",
  we_provide_store_data: "come raccogliamo, elaboriamo e memorizziamo le informazioni.",
  leaving_company_text: "Vuoi davvero lasciare l'azienda? Lasciando l'azienda lascerai anche tutti i progetti e i gruppi di chat associati. Puoi riunirti a questi progetti con un'altra azienda in qualsiasi momento.",
  delete_profile_text: "Vuoi davvero eliminare il tuo profilo? Quando elimini il tuo profilo, tutte le connessioni ad aziende, progetti e chat verranno rimosse. Puoi creare un nuovo profilo in qualsiasi momento.",
  confirm: "Conferma",
  reject: "Rifiuta",
  requet_to_leave: "Richiesta di uscita",
  choose: "Scegli",
  your_add_member: "Aggiungi membro",
  if_you: "se tu",
  can_not_find: "non riesci a trovare il tuo contatto qui.",
  please_wait: "Attendere prego...",
  imprint_gtc: "Note legali/CGV",
  register_confirm_title: "Conferma l'e-mail prima di accedere",
  register_confirm_popup: "Verifica il tuo indirizzo e-mail Kjuup prima di accedere. L'accesso è possibile solo dopo questa conferma. Ti abbiamo inviato un link di conferma. Se non lo vedi, controlla anche la cartella spam.",
  resend_confirmation_email: "Invia di nuovo l'e-mail di conferma",
  resend_confirmation_sent: "Se questo indirizzo e-mail è in attesa di conferma, abbiamo inviato un nuovo link.",
  PENDING_GROUP_USER: "riceverà messaggi solo dopo che l'invito al progetto sarà confermato. Un messaggio aggiuntivo apparirà una volta confermato l'invito al progetto.",
  PENDING: "Conferma dell'invito al progetto in sospeso",
  denied_group_chat: " ha rifiutato l'invito al progetto e ha lasciato questo gruppo.",
  joined_group_chat: " si è unito a questo gruppo",
  you_joined_group_chat: "Ti sei unito a questo gruppo.",
  Others: "Altri",
  LEFT_GROUP: "ha lasciato questo gruppo di chat.",
  YOU_LEFT_GROUP: "hai lasciato questo gruppo di chat.",
  days: "giorni",
  day: "giorno",
  hour: "ora",
  hide_project: "Nascondi progetto",
  hide_project_popup_text: "Se nascondi i progetti, non possono essere trovati all'interno di Kjuup. Solo i membri del progetto possono invitare nuovi utenti.",
  branch: "Settore",
  photo_video_media_lib: "Libreria multimediale foto - video",
  video_too_large: "I video devono essere di massimo 200 MB.",
  video_too_long: "I video devono durare al massimo 15 minuti.",
  video_invalid: "Impossibile leggere questo video.",
  video_one_at_a_time: "Seleziona un solo video alla volta.",
  video_or_images_only: "Seleziona immagini oppure un singolo video.",
  video_processing: "Compressione video…",
  video_uploading: "Caricamento video…",
  article_publish_preparing: "Preparazione…",
  article_publish_compressing_video: "Compressione video…",
  article_publish_preparing_media: "Preparazione foto…",
  article_publish_uploading: "Caricamento media…",
  article_publish_finishing: "Pubblicazione…",
  document: "Documento",
  location: "Posizione",
  location_meeting: "Posizione / Riunione",
  all_member_of_project: "Tutti i membri del progetto",
  pending_request: "Inviti progetto in sospeso",
  no_pending_request: "Nessuna richiesta in sospeso trovata!",
  news_feed: "Notizie",
  user_info: "Info gruppo",
  leave_project: "Lascia progetto",
  media_link_docs: "File",
  search_chat: "Cerca nella chat",
  export_chat_group: "Esporta dati del gruppo chat dell'ultimo mese",
  request_complete_chat_history: "Richiedi cronologia chat completa",
  leave_chat_group: "Lascia gruppo chat",
  add_user_project: "Aggiungi utente",
  me: "Io",
  max_open_one_to_one: "Attualmente max. 2 chat individuali possono essere aperte in parallelo nella sezione inferiore e superiore. In totale sono possibili max. 4 chat individuali.",
  are_you_sure_you_want_leave_chat: "Sei sicuro di voler lasciare questo gruppo chat?",
  create_group: "Crea gruppo",
  adding_members: "Aggiunta dei membri...",
  creating_the_chat: "Creazione della chat...",
  finishing_setup: "Completamento...",
  group_name: "Nome gruppo",
  by: "Da:",
  mandetory: "*obbligatorio",
  delteed: "ha eliminato il suo profilo e ha lasciato il gruppo chat.",
  deleted_direct: "ha eliminato il suo profilo e ha lasciato la chat.",
  unhidden_message: "Se mostri i progetti, possono essere trovati da tutti i membri di Kjuup.",
  account_deleted: "L'account è stato eliminato.",
  refuse_company: "Sei sicuro di voler rifiutare l'invito dell'azienda?",
  follow_additional: "Segui altri utenti",
  f_add: "Segui altri utenti di Kjuup per renderli disponibili per i messaggi diretti.",
  c_inv: "Invito/i azienda",
  invited_o_Company: "Sei stato invitato a unirti all'azienda",
  refuse_companyX: "Sei sicuro di voler rifiutare la richiesta dell'azienda?",
  a_Da: "Account disattivato.",
  has_deactivated: "ha disattivato il suo profilo.",
  reactive: "ha riattivato il suo profilo.",
  juup_note: "*La registrazione con nome utente è disponibile solo per i membri di Kjuup+",
  username: "Nome utente*",
  email_username: "E-mail/Nome utente*",
  sPinText: "Fornisci un PIN di sicurezza a 6 cifre. Questo PIN sarà necessario in caso di dimenticanza della password ed è obbligatorio per confermare il tuo account.",
  DeleteKjuupPlusText: "Vuoi davvero eliminare il tuo profilo? Quando elimini il tuo profilo, tutte le connessioni ad aziende, progetti e chat verranno rimosse.\n\nEntro 48 ore dall'eliminazione dell'account puoi riattivare il tuo account accedendo con nome utente, password e PIN.",
  reactive_text: "Il tuo account è stato eliminato. Clicca su Riattiva per riattivare il tuo account.",
  rac: "Riattiva",
  ac_ss: "Account riattivato con successo.",
  not_valid_pin: "PIN non valido",
  only_for_kjuup: "*Il reset della password tramite nome utente e PIN è disponibile solo per i membri Kjuup+.",
  resetPIN: "Reimposta PIN",
  enter_current_pin: "Inserisci il tuo PIN attuale",
  enter_new: "Inserisci nuovo PIN",
  pin_to_confirm: "Fornisci il PIN per confermare.",
  change_username: "Reimposta nome utente",
  pp_not_match: "Password e Conferma password non corrispondono",
  reactive_itself: "Hai riattivato il tuo profilo.",
  has_deactivated_itself: "Hai disattivato il tuo profilo.",
  more_than_two: "Attualmente i messaggi diretti possono essere fatti solo con 2 utenti in parallelo.",
  Chats: "Messaggi diretti",
  only_in_mobileL: "I video nativi attualmente possono essere caricati e pubblicati solo tramite l'app mobile. Usa link video di Youtube e Vimeo.",
  register_pin_text: "Scegli il tuo PIN personale a 6 cifre. Questo PIN sarà necessario per abilitare le funzionalità di reset dell'account.",
  internal_project: "Interno",
  external_projects: "Esterno",
  in_deacticted: "La sezione interna è disattivata.",
  create_article: "Crea articolo",
  new_article_selection: "Crea articolo per il feed notizie esterno",
  new_article_selection_internal: "Crea articolo interno",
  active_trans_title: "Attivare la traduzione automatica?",
  active_trans: "Quando attivata, tutti i messaggi di chat in arrivo verranno tradotti nella lingua dell'app selezionata.",
  disable_trans: "Vuoi davvero disattivare la traduzione automatica?",
  allow_access_chat: "Mostra cronologia chat completa",
  toggle_chat_history_on: "Vuoi davvero che l'utente veda la cronologia chat completa?",
  toggle_chat_history_off: "Vuoi davvero che l'utente veda la cronologia chat solo dal momento dell'iscrizione?",
  check_selected_settings: "Controlla le impostazioni della cronologia chat per tutti gli utenti selezionati!",
  chat_from_start_have: "Ti sei unito a questo gruppo. La cronologia chat è stata condivisa.",
  chat_from_start_has: "si è unito a questo gruppo. La cronologia chat è stata condivisa.",
  Address: "Indirizzo",
  read_by: "Letto da",
  deliver_to: "Consegnato a",
  remaining: "rimanente",
  message_info: "Info messaggio",
  request_to_join_only: "Richiesta di unirsi",
  unfollow: "Smetti di seguire",
  company_username: "Nome utente",
  month: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"],
  remove_my_admin_right: "Rimuovi i miei diritti admin",
  makeEmp: "Vuoi davvero rimuovere i diritti admin aziendali dall'utente?",
  remove_my_self: "Vuoi davvero rimuovere i diritti admin aziendali dal tuo account?",
  makeAdmin: "Vuoi davvero dare i diritti admin aziendali all'utente?",
  remove_member: "Rimuovi membro",
  remove_following_confirm: "Vuoi davvero rimuovere {name} dalla lista dei seguiti?",
  remove_follower_confirm: "Vuoi davvero rimuovere {name} dai tuoi follower? Se lo/la rimuovi non verrà informato/a.",
  do_you_really_want_to_remove: "Vuoi davvero rimuovere l'utente dall'azienda?",
  invite_all: "Invita tutti i membri dell'azienda",
  invite_all_members: "Invita tutti i membri",
  mems: "Tutti gli altri membri",
  dep_loc: "Dipartimento/Sede/Team",
  depAdmin: "Admin dipartimento",
  add_remove_admin: "Aggiungi/Rimuovi posizione admin aziendale",
  add_remove_dep_admin: "Aggiungi/Rimuovi posizione admin dipartimento",
  remove_employees_dept: "Rimuovi dipendenti da",
  want_to_join_dep: "L'utente vuole unirsi al Dipartimento/Sede/Team dell'azienda.",
  you_invited: "Sei stato invitato a unirti al Dipartimento/Sede/Team dell'azienda.",
  dep_remove: "Vuoi davvero rimuovere i diritti admin per il dipartimento o la sede dall'utente?",
  add_dep: "Vuoi davvero dare i diritti admin per il dipartimento o la sede all'utente?",
  my_self_dep_remove: "Vuoi davvero rimuovere i diritti admin dipartimento dal tuo account?",
  member: "Membro",
  admin: "Admin",
  remove_project_admin: "Vuoi davvero rimuovere il membro dal progetto?",
  remove_my_self_project: "Vuoi davvero rimuovere i diritti admin?",
  remove_member_admin_right: "Vuoi davvero rimuovere i diritti admin dall'utente?",
  add_member_admin_right: "Vuoi davvero aggiungere i diritti admin all'utente?",
  add_remove_Poss: "Aggiungi/Rimuovi posizione admin",
  forward: "Inoltra",
  forward_to: "Inoltra a...",
  edit: "Modifica",
  only_kjuup_plus_can: "Solo le aziende Kjuup+ possono pubblicare articoli.",
  add_images: "Aggiungi immagine/i",
  Activity: "Attività",
  latest_messages: "Ultimi messaggi",
  hours: "ore",
  minute: "minuti",
  seconds: "secondi",
  yesterday: "ieri",
  last_week: "La settimana scorsa",
  this_week: "Questa settimana",
  next_week: "la prossima settimana",
  Last_month: "Il mese scorso",
  this_month: "Questo mese",
  All: "Tutto",
  register_plus: "Registrazione Plus",
  select_files: "Seleziona file",
  monthsFullName: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
  company_deploc_receivers_message: "Link di invito al dipartimento dell'azienda in Kjuup. Clicca sul link per registrarti a Kjuup e unirti all'azienda.",
  no_news: "Nessuna notizia disponibile",
  reminder: "Promemoria",
  np_reminder: "Nessun compito",
  move_to_reminder: "Sposta in Compiti",
  remove_reminder: "Vuoi davvero rimuovere questo messaggio dalla lista dei tuoi compiti?",
  remove_all_reminder: "Rimuovi tutti i compiti",
  remove_all_confirm: "Vuoi davvero rimuovere tutti i messaggi dalla lista dei tuoi compiti?",
  remove_from_reminder: "Rimuovi dal promemoria",
  prevent_email: "L'e-mail non può essere usata come nome utente.",
  allow_noti: "Consenti le notifiche.",
  join_cap: "Unisciti",
  pass_minimum: "**La password richiede 12 caratteri inclusa lettera minuscola, maiuscola, numero e carattere speciale.",
  pass_error: "Controlla i requisiti della password",
  people_that_like_article: "Persone a cui piace l'articolo.",
  people_who_like_article: "Persone a cui piace il tuo articolo.",
  message_delete: "Questo messaggio è stato eliminato.",
  message_edited: "modificato",
  edit_message: "Modifica messaggio",
  edit_window_expired: "I messaggi possono essere modificati solo entro 10 minuti dall'invio.",
  message_edit_save: "Salva",
  copy: "Copia",
  bookmark: "Segnalibro",
  add_reaction: "Aggiungi reazione",
  delete_message: "Elimina messaggio",
  more_options: "Altre opzioni",
  info: "Info",
  delete_message_confirm: "Vuoi davvero eliminare questo messaggio?",
  link_invite: "Invita tramite link",
  ll_nkk: "Invita su Kjuup",
  selected: "Selezionato",
  is_active: "Attivo",
  inactive: "Inattivo",
  last_online: "ultimo accesso {{when}}",
  remove_user_l: "Rimuovi",
  link_expire: "Ogni link generato sarà valido per 72 ore.",
  company_language: "Lingua aziendale",
  company_language_info: "La selezione della lingua verrà utilizzata per tutte le conferme e-mail riguardanti l'azienda.",
  s_image: "immagine",
  m_image: "immagini",
  removeMsg: "Tocca per rimuovere",
  block: "Blocca",
  unblock: "Sblocca",
  blocks: "Sei sicuro di voler bloccare questo utente?",
  unblocks: "Sei sicuro di voler sbloccare questo utente?",
  bolcked_click_un_block: "Hai bloccato questo contatto. Clicca qui per rimuovere il blocco.",
  you_have_unblocked: "Hai sbloccato questo contatto.",
  you_have_blocked: "Hai bloccato questo contatto.",
  unblock_to_send: "Sblocca l'utente per inviare messaggi.",
  pilot_text: "IA specializzata per argomenti di costruzione",
  startup_screen_label: "Schermata iniziale",
  startup_screen_info: "Scegli quale schermata si apre all'avvio di Kjuup.",
  startup_screen_feed: "Home",
  startup_screen_messages: "Messaggi",
  startup_screen_saved: "Schermata iniziale aggiornata",
email_on: "Notifica e-mail per le chat",
  email_on_grp: "Notifica e-mail",
  article_email_on: "Notifica e-mail articoli",
  article_email_info: "Se abiliti le notifiche e-mail per gli articoli interni, riceverai un'e-mail quando viene pubblicato un nuovo articolo interno nella tua azienda e nel tuo dipartimento.",
  info_email_room: "Attiva o disattiva le notifiche e-mail per questo progetto.",
  todo_notification_info: "Riceverai una notifica ogni volta che ti viene assegnato un nuovo ToDo.",
  info_val: "Riceverai un'e-mail se un nuovo messaggio in chat non viene letto entro breve tempo. Puoi disattivarla per singoli progetti o chat nelle rispettive impostazioni o nelle info del gruppo.",
  email_groups: "Attiva o disattiva le notifiche e-mail per questa chat.",
  add_update_email: "Aggiungi/Aggiorna e-mail",
  text_to_verifiy: "L'opzione \"Notifica e-mail per le chat\" può essere abilitata solo se hai un indirizzo e-mail verificato registrato.",
  stored_email: "E-mail registrata: ",
  verify_email: "Conferma in sospeso!",
  join_call: "Unisciti",
  call_is_started: "Chiamata avviata",
  start_chat: "Iniziare chat diretta?",
  project_rooms: "Progetti",
  download_selected: "Scarica",
  download_to_folder: "Salva in una cartella",
  download_as_zip: "Scarica come ZIP",
  media_download_progress: "Download {current} di {total}",
  media_downloaded_on: "Immagini scaricate il {datetime}",
  docs_downloaded_on: "Documenti scaricati il {datetime}",
  media_auto_download: "Download automatico dei media",
  media_auto_download_hint: "Le nuove immagini e i documenti vengono salvati alle 20:00",
  media_auto_download_info: "Scegli una cartella una sola volta. Le nuove immagini e i documenti di questa chat o di questo progetto vengono salvati automaticamente ogni giorno alle 20:00. Se Kjuup è chiuso a quell'ora, il download avviene alla successiva apertura dell'app.",
  media_auto_download_unsupported: "La selezione della cartella richiede Chrome o Edge",
  media_auto_download_continue: "Consenti l'accesso alla cartella per continuare",
  media_export_server: "Server di esportazione media",
  media_export_server_info: "Collega un server WebDAV o SFTP. Ogni chat e progetto può poi esportare i nuovi media nella propria cartella ogni sera alle 20:00.",
  media_export_protocol: "Protocollo",
  media_export_host: "Host",
  media_export_port: "Porta",
  media_export_username: "Nome utente",
  media_export_password: "Password",
  media_export_base_path: "Percorso di base (opzionale)",
  media_export_test: "Prova connessione",
  media_export_test_ok: "Connessione riuscita",
  media_export_test_fail: "Connessione non riuscita",
  media_export_saved: "Connessione salvata",
  media_export_disconnect: "Disconnetti",
  media_export_disconnect_confirm: "Disconnettere questo server di file?",
  media_export_folder: "Esportazione notturna dei media",
  media_export_folder_placeholder: "/Progetti/Alpha",
  media_export_nightly_hint: "Nuove immagini, video e documenti vengono caricati alle 20:00",
  media_export_nightly_info: "Nuove immagini, video e documenti vengono caricati ogni sera alle 20:00 nel percorso della cartella sul server aziendale. L'app non deve essere aperta.",
  media_export_admin_required: "Un file server deve essere collegato nell'Admin Panel.",
  media_export_readonly: "Esporta ogni notte in {path}",
  media_export_last_error: "Ultima esportazione non riuscita",
  change: "Cambia",
  add_employee_confirm: "Sei sicuro di voler aggiungere questo utente all'azienda?",
  invalid_deeplink: "URL deeplink non valido. Parametri richiesti mancanti.",
  deeplink_error: "Impossibile elaborare il deeplink. Riprova più tardi.",
  reply: "Rispondi",
  reply_enter: "Inserisci risposta...",
  reply_sent_successfully: "Risposta inviata con successo",
  reply_failed: "Invio risposta fallito",
  reply_failed_generic: "Invio risposta fallito. Riprova.",
  replying_to_message: "Risposta al messaggio",
  cancel_reply: "Annulla risposta",
  voice_message: "Messaggio vocale",
  send: "Invia",
  type_your_reply: "Scrivi la tua risposta...",
  
  // Auto-suggestion translations
  suggested_replies: "Risposte suggerite",
  suggestions_error: "Impossibile caricare i suggerimenti",
  positive_suggestion_placeholder: "Positive",
  neutral_suggestion_placeholder: "Neutral",
  negative_suggestion_placeholder: "Negative",
  lazy_media_image: "Immagine — Clicca per caricare",
  lazy_media_audio: "Messaggio vocale — Clicca per caricare",
  lazy_media_doc: "Documento — Clicca per caricare",
  lazy_media_video: "Video — Clicca per caricare",
  suggestion_loading_message: "Solo un momento. Il tuo testo viene preparato individualmente per te.",
  loading_chat_message: "Caricamento chat...",
  
  // Manual ToDo translations
  extracting_message: "Estrazione del messaggio...",
  create_todo: "Crea attività",
  create_todo_confirmation: "Vuoi creare un'attività da questo messaggio?",
  todo_summary: "Riepilogo",
  todo_summary_placeholder: "Inserisci il riepilogo dell'attività...",
  todo_date: "Data",
  todo_time: "Ora",
  deadline: "Scadenza",
  todo_date_hint: "Lascia vuoto per usare la data/ora del messaggio originale",
  todo_created_success: "Attività creata con successo",
  todo_creation_failed: "Impossibile creare l'attività",
  create: "Crea",
  
  image: "immagine",
  images: "immagini",
  remove_all_images: "Rimuovi tutte le immagini",
  remove_image: "Rimuovi immagine",
  remove_document: "Rimuovi documento",
  remove_recording: "Rimuovi registrazione",
  play_recording: "Riproduci registrazione",
  upload_image: "Carica immagine",
  upload_document: "Carica documento",
  record_audio: "Registra audio",
  stop_recording: "Ferma registrazione",
  stop_recording_text: "Ferma registrazione",
  please_remove_current_attachment: "Rimuovi l'allegato corrente per",
  please_upload_image_file: "Carica un file immagine valido",
  please_upload_valid_document: "Carica un file documento valido",
  searching_messages: "Ricerca messaggi...",
  loading_more: "Caricamento...",
  loading_more_users: "Caricamento altri utenti...",
  load_more_users: "Carica più utenti",
  no_more_users_to_load: "Nessun altro utente da caricare",
  no_messages_found: "Nessun messaggio trovato",
  try_different_keyword: "Prova una parola chiave diversa o controlla l'ortografia.",
  search_messages: "Cerca messaggi, gruppi chat, progetti e utenti...",
  search_groups: "Gruppi",
  search_chat_groups: "Gruppi di chat",
  search_project_room: "Progetto",
  search_messages_tab: "Messaggi",
  searching_groups: "Ricerca gruppi...",
  searching_rooms: "Ricerca progetti...",
  no_groups_found: "Nessun gruppo trovato",
  no_rooms_found: "Nessun progetto trovato",
  search_users_tab: "Utenti",
  search_documents_tab: "Documenti",
  company_documents: "Company documents",
  company_documents_empty: "No documents available.",
  no_media_available: "Nessun file",
  no_documents_available: "Nessun documento",
  searching_users: "Ricerca utenti...",
  no_users_found: "Nessun utente trovato",
  search_emails_tab: "E-mail",
  searching_emails: "Ricerca e-mail...",
  no_emails_found: "Nessuna e-mail trovata",
  search_email_addresses_tab: "Indirizzi e-mail",
  search_email_content_tab: "Contenuto e-mail",
  searching_email_content: "Ricerca contenuto e-mail...",
  no_email_content_found: "Nessun contenuto e-mail trovato",
  search_email_attachments_tab: "Allegati e-mail",
  searching_email_attachments: "Ricerca allegati...",
  no_email_attachments_found: "Nessun allegato trovato",
  email_attachments_label: "Allegati",
  searching_email_addresses: "Ricerca indirizzi...",
  no_email_addresses_found: "Nessun indirizzo trovato",
  search_email_filter_all: "Tutti",
  search_email_filter_content: "Contenuto",
  search_email_filter_addresses: "Indirizzi",
  search_email_filter_attachments: "Allegati",
  search_email_filter_has_attachments: "Con allegati",
  search_email_filter_unread: "Non letti",
  search_email_combo_placeholder: "Nelle e-mail di (opzionale)…",
  search_email_combo_content_placeholder: "Cerca in queste e-mail…",
  search_email_combo_hint: "Ricerca nelle e-mail di",
  search_email_combo_containing: "contenenti",
  search_describe: "Descrivi cosa stai cercando…",
  search_describe_examples_with_email: "es. e-mail di ml@bl2020.com con password · messaggi di Martin su fattura · utente Martin Langen",
  search_intent_understood: "Ricerca",
  search_intent_emails: "E-mail",
  search_intent_messages: "Messaggi",
  search_intent_user: "Utente",
  search_submit: "Cerca",
  email_subject_label: "Oggetto",
  email_body_label: "Corpo",
  email_address_received: "Ricevuti",
  email_address_sent: "Inviati",
  todo: "Compiti",
  np_todo: "Nessun compito",
  move_to_todo: "Salva come compito",
  remove_todo: "Vuoi davvero rimuovere il compito?",
  remove_all_todo: "Rimuovi tutti i compiti",
  remove_all_todo_confirm: "Vuoi davvero rimuovere tutti i compiti?",
  add_to_todo: "Aggiungi ai compiti",
  remove_from_todo: "Rimuovi dai compiti",
  read_more: "Leggi di più",
  show_less: "Mostra meno",
  show_more: "Mostra altro",
  audio: "Audio",
  video: "Video",
  notification_schedule: "Programma notifiche",
  notification_schedule_desc: "Riceverai notifiche push ed e-mail solo nelle ore che scegli. Al di fuori di quegli orari, verranno sospese.",
  learn_more: "Scopri di più",
  allow_notifications: "Consenti notifiche:",
  every_day: "Ogni giorno",
  weekdays: "Giorni feriali (da lunedì a venerdì)",
  custom: "Personalizzato",
  monday: "Lunedì",
  tuesday: "Martedì",
  wednesday: "Mercoledì",
  thursday: "Giovedì",
  friday: "Venerdì",
  saturday: "Sabato",
  sunday: "Domenica",
  notification_settings: "Notifiche",
  notification_settings_saved: "Impostazioni notifiche salvate con successo",
  notification_settings_error: "Salvataggio impostazioni notifiche fallito",
  unavailability_note: "Nota di assenza",
  unavailability_description: "Imposta una nota di assenza. Finché attiva, la nota viene mostrata agli altri in tutte le chat e le notifiche vengono sospese.",
  unavailability_start_date: "Data di inizio",
  unavailability_end_date: "Data di fine",
  unavailability_message: "Messaggio",
  unavailability_message_hint: "Usa {endDate} come segnaposto per la data di rientro.",
  unavailability_replacement: "Contatto sostituto",
  unavailability_replacement_placeholder: "Inserire l'ID utente per richieste urgenti",
  unavailability_replacement_current: "Sostituto attuale",
  unavailability_replacement_hint: "Se impostato, un link per contattare questa persona per questioni urgenti verrà mostrato nella nota di assenza.",
  unavailability_replacement_none: "Nessun sostituto (opzionale)",
  unavailability_contact_urgent: "Per richieste urgenti contattare",
  unavailability_default_message: "Al momento non sono in ufficio e non ho accesso a Kjuup. Sarò nuovamente disponibile dal {endDate} e vi ricontatterò allora.",
  unavailability_save: "Salva",
  unavailability_deactivate: "Disattiva",
  unavailability_active_until: "Attivo fino al",
  unavailability_saved: "Nota di assenza salvata",
  unavailability_save_error: "Errore nel salvataggio della nota di assenza",
  unavailability_deactivated: "Nota di assenza disattivata",
  unavailability_end_date_required: "La data di fine è obbligatoria",
  start_time_before_end_time: "L'ora di inizio deve essere prima dell'ora di fine",
  loading: "Caricamento",
  disabled: "Disabilitato",
  enable: "Abilita",
  disable: "Disabilita",
  forwarded: "Inoltrato",
  message_forwarded: "Messaggio inoltrato!",
  schedule_article_post: "Pianifica pubblicazione articolo",
  date: "Data",
  time: "Ora",
  scheduled_for_publication: "Pianificato per la pubblicazione",
  article_will_be_published_on: "L'articolo sarà pubblicato il:",
  reset_selection: "Reimposta selezione",
  error_loading_members: "Errore caricamento membri",
  please_fill_all_fields: "Compila tutti i campi",
  invalid_email: "Indirizzo e-mail non valido",
  member_added_successfully: "Membro aggiunto con successo",
  error_onboarding_user: "Errore nell'aggiunta dell'utente",
  error_creating_chat: "Errore nella creazione della chat",
  error_creating_group: "Errore nella creazione del gruppo",
  new_group: "Nuovo gruppo",
  please_select_or_enter_group_name: "Seleziona un gruppo o inserisci un nome gruppo",
  please_select_or_enter_room_name: "Seleziona un progetto o inserisci un nome progetto",
  error_creating_room: "Errore nella creazione del progetto",
  error_opening_chat: "Errore nell'apertura della chat",
  privacy_modal_text: "Seleziona \"Privato\" solo se la chat non contiene contenuti professionali rilevanti per il project manager.",
  not_private: "Non privato",
  private: "Privato",
  error_loading_groups: "Errore nel caricamento dei gruppi",
  automatic_chat_export: "Esportazione automatica chat",
  automatic_chat_export_info: "Dopo l'attivazione, la cronologia chat verrà automaticamente inviata all'indirizzo e-mail specificato ogni mese.",
  automatic_chat_export_no_email: "Per attivare l'esportazione automatica della chat, devi prima aggiungere un indirizzo e-mail. Puoi aggiungere il tuo indirizzo e-mail nelle impostazioni personali.",
  enter_email: "Inserisci e-mail",
  export_to_email: "L'esportazione va alla seguente e-mail.",
  start_chat_button: "Nuovo messaggio",
  start_direct_message: "Iniziare messaggio diretto?",
  matching_existing_chats: "Chat esistenti corrispondenti",
  subject: "Oggetto",
  add_subject: "Aggiungi oggetto",
  chat_subject: "Oggetto chat:",
  set_project_room: "Imposta progetto",
  matching_existing_project_rooms: "Progetti esistenti corrispondenti",
  name_project_room: "Nome progetto",
  professional_or_private: "Professionale o privato",
  professional: "Professionale",
  privacy_modal_text_updated: "Seleziona \"Privato\" solo se la chat non contiene contenuti professionali rilevanti per i project manager. Le chat private non sono visibili ai project manager.",
  create_internal_chat: "Chat esterno o interno?",
  internal_chat_description: "Solo i dipendenti della tua azienda possono essere aggiunti alle chat interne.",
  yes: "Sì",
  no: "No",
  chat_is_being_created: "La chat è in fase di creazione...",
  discard_article_confirm: "Vuoi davvero annullare le modifiche a questo articolo?",
  please_enter_article_title: "Inserisci prima il titolo dell'articolo.",
  please_add_mandatory_fields: "Aggiungi tutti i campi obbligatori",
  product_label: "Prodotto:",
  no_companies_found: "Nessuna azienda trovata",
  visible_to_all_followers: "Visibile a tutti i membri Kjuup",
  only_visible_to_employees: "Visibile solo ai dipendenti",
  something_went_wrong: "Qualcosa è andato storto, riprova",
  please_select_department: "Seleziona dipartimento/sede",
  schedule: "Pianifica",
  please_select_future_date_time: "Seleziona una data e un'ora future per pianificare l'articolo.",
  please_select_different_date_time: "Seleziona una data o un'ora diversa per pianificare l'articolo.",
  please_select_later_time: "Seleziona un'ora successiva all'ora corrente per oggi.",
  unpin_article: "Rimuovi fissaggio articolo",
  pin_article: "Fissa articolo",
  and: "e",
  others: "altri",
  at: "alle",
  mute: "Silenzia",
  unmute: "Riattiva audio",
  chat_muted_successfully: "Chat silenziata con successo",
  chat_unmuted_successfully: "Audio chat riattivato con successo",
  mute_chat_confirm: "Vuoi davvero silenziare questa chat? Non riceverai più notifiche per i nuovi messaggi.",
  unmute_chat_confirm: "Vuoi davvero riattivare l'audio di questa chat? Riceverai di nuovo notifiche per i nuovi messaggi.",
  please_select_group_to_forward: "Seleziona un gruppo per inoltrare il messaggio",
  record_not_found: "Nessun record trovato!",
  please_select_position: "Seleziona una posizione",
  delete_article_confirm: "Sei sicuro di voler eliminare questo articolo?",
  delete_company_service_confirm: "Sei sicuro di voler eliminare il servizio aziendale?",
  block_translation_confirm: "Vuoi davvero bloccare la traduzione automatica nei progetti per tutti i membri dell'azienda",
  unblock_translation_confirm: "Vuoi davvero sbloccare la traduzione automatica nei progetti per tutti i membri dell'azienda",
  please_select_file: "Seleziona un file da caricare",
  role_in_building_industry: "Ruolo nell'industria edile*",
  invalid_email_address: "Indirizzo e-mail non valido",
  please_enter_password: "Inserisci la password",
  password_change_email_sent: "È stata inviata un'email al tuo indirizzo email Kjuup. Conferma la nuova password cliccando sul link di conferma nell'email.",
  please_enter_username: "Inserisci il nome utente",
  username_same_as_before: "Il nome utente non può essere lo stesso di prima",
  profile_deleted_successfully: "Profilo eliminato con successo",
  hardware_requirements: "Requisiti hardware",
  hardware_requirements_list: "• 4 GB RAM<br/>• Velocità CPU min. 2 GHz<br/>• Windows 7 o superiore / tutte le versioni macOS",
  submitting: "Invio in corso...",
  signing_in: "Accesso in corso...",
  please_enter_service_name: "Inserisci il nome del servizio",
  something_went_wrong_error: "Ops! Qualcosa è andato storto...",
  something_went_wrong_try_again: "Spiacenti, qualcosa è andato storto. Riprova",
  position_label: "Posizione:",
  loading_room: "Caricamento progetto...",
  navigating_to_room: "Navigazione al progetto",
  loading_chat: "Caricamento chat...",
  translate: "Traduci",
  show_original: "Mostra originale",
  saving: "Salvataggio...",
  language_selection_info: "La selezione della lingua viene utilizzata per tutte le conferme e-mail relative all'azienda.",
  // Navigation bar labels
  nav_call: "Chiamata",
  nav_home: "Home",
  nav_messages: "Messaggi",
  nav_todo: "Attività",
  nav_rooms: "Progetti",
  nav_all_rooms: "Tutti i progetti",
  pinned_rooms_max: "Puoi fissare fino a 10 progetti.",
  pinned_room_unpin: "Rimuovi",
  pinned_rooms_drop: "Trascina qui il tuo progetto per una selezione rapida",
  nav_profile: "Profilo",
  nav_company: "Azienda",
  nav_company_documents: "Documenti",
  nav_logout: "Esci",
  // Create message dialog
  add_member_title: "Aggiungi membro",
  continue_btn: "Continua",
  search_placeholder: "Cerca",
  no_members_found: "Nessun membro trovato",
  no_groups_found: "Nessun gruppo trovato",
  no_rooms_found: "Nessun progetto trovato",
  unnamed_group: "Gruppo senza nome",
  unnamed_room: "Progetto senza nome",
  all_members: "Tutti",
  room_label: "Progetto:",
  subject_label: "Oggetto:",
  no_members: "Nessun membro",
  // Loading states for room creation
  creating_structure: "Creazione della struttura",
  opening_chat: "Apertura della chat",
  please_wait: "Attendere prego...",
  // ToDo page translations
  loading_todo: "Caricamento ToDo...",
  task_updated: "Attività aggiornata",
  error_updating_task: "Errore durante l'aggiornamento dell'attività",
  task_deleted: "Attività eliminata",
  error_deleting_task: "Errore durante l'eliminazione dell'attività",
  delete_task_confirm: "Sei sicuro di voler eliminare questa attività?",
  delete_multiple_tasks_confirm: "Sei sicuro di voler eliminare {count} ToDo?",
  delete_selected_count: "Elimina ({count})",
  todo_multi_delete: "Elimina più ToDo",
  todo_multi_delete_hint: "Seleziona i ToDo da eliminare",
  todos_deleted_count: "{count} ToDo eliminati",
  todos_deleted_partial: "{ok} ToDo eliminati, {fail} non riusciti",
  delete_only_own: "Puoi eliminare solo i ToDo che hai creato",
  description_label: "Descrizione",
  description_placeholder: "Inserisci descrizione...",
  date_time_label: "Data e ora",
  save_hint: "Ctrl+Invio per salvare, Esc per annullare",
  edit_label: "Modifica",
  delete_label: "Elimina",
  todo_list_title: "Attività",
  tasks_count: "attività",
  search_placeholder_todo: "Cerca...",
  select_task_to_open_chat: "Seleziona un'attività per aprire la chat",
  today: "Oggi",
  yesterday: "Ieri",
  time_suffix: "", // Empty for Italian (24h format doesn't need suffix)
  from_chat: "Fonte ToDo",
  assigned_to: "Assegnato a",
  assign_users: "Assegna utenti",
  assigned_users: "Utenti assegnati:",
  no_users_assigned: "Nessun utente assegnato",
  assign: "Assegna",
  assign_to: "Assegna a...",
  navigate_to_chat: "Vai alla chat",
  navigate_to_email: "Vai all'email",
  show_original_message: "Mostra fonte",
  hide_original_message: "Nascondi fonte",
  status_pending: "In attesa",
  status_in_progress: "In corso",
  status_completed: "Completato",
  show: "Mostra",
  close: "Chiudi",
  // Additional ToDo translations
  todo_beta: "BETA",
  todo_project_label: "Progetto:",
  todo_chat_label: "Chat:",
  todo_assigned_by: "Assegnato da:",
  todo_assigned_push: "ToDo assegnato:",
  todo_assigned_push_empty: "Ti è stato assegnato un nuovo ToDo.",
  todo_clear_all: "Cancella tutto",
  todo_unknown: "Sconosciuto",
  filter_all: "Tutti",
  filter_assigned_to_me: "Le mie attività",
  filter_assigned_by_me: "Delegato",
  completed_by: "Completato da:",
  verify_completion: "Verifica",
  back_into_in_progress: "Torna in corso",
  unassign_todo: "Rimuovi assegnazione",
  unassign_label: "Rimuovi",
  me: "Io",
  search_or_select_project: "Cerca o seleziona progetto...",
  // Confirmed ToDo and History translations
  status_confirmed: "Confermato",
  history: "Cronologia",
  marked_as: "Contrassegnato come",
  at_date: "il",
  at_time: "alle",
  time_suffix: "",
  all_todos: "ToDo aperti",
  confirmed_todos: "ToDo confermati",
  filter_pending: "In sospeso",
  filter_confirmed: "Confermato",
  my_list: "La mia giornata",
  todo_adjust_list: "Modifica lista",
  apply: "Applica",
  move_back_in_progress: "Rimetti in corso",
  no_history_yet: "Nessuna cronologia",
  todo_status_updated: "Stato del todo aggiornato da {from} a {to}",
  todo_status_updated_from: "da",
  todo_status_updated_to: "a",
  // Log description translations
  log_todo_created: "ToDo creato",
  log_todo_confirmed: "ToDo confermato",
  log_todo_deleted: "ToDo eliminato",
  log_todo_updated: "ToDo aggiornato",
  log_description_updated: "Descrizione aggiornata",
  log_deadline_updated: "Scadenza aggiornata",
  log_assigned_to: "Assegnato a {name}",
  log_unassigned_from: "Rimosso da {name}",
  log_assignment_added: "Assegnazione aggiunta: {name}",
  log_assignment_removed: "Assegnazione rimossa: {name}",
  log_status_updated: "Stato modificato da {from} a {to}",
  log_status_changed: "Stato modificato",
  log_status_changed_to: "Stato modificato in {status}",
  log_changed_status_to: "Stato cambiato in:",
  log_for_user: "per utente:",
  log_user_updated_status: "L'utente ha aggiornato lo stato del ToDo",
  log_changed_date_to: "Data modificata in:",
  log_changed_description_to: "Descrizione modificata in:",
  log_moved_to: "Spostato a {status}",
  // ToDo filter translations
  todo_filters: "Filtri",
  todo_filter_by_project: "Filtra per progetto",
  todo_status: "Stato",
  todo_assignment: "Assegnazione",
  todo_filter_by_user: "Filtra per persona assegnata",
  todo_active_filters: "Filtri attivi:",
  todo_progress: "Progresso",
  todo_my_list_empty: "La tua giornata è vuota",
  todo_my_list_empty_hint: "Clicca sul pulsante sopra per aggiungere compiti",
  create_poll: "Sondaggio",
  poll_question_label: "DOMANDA",
  poll_question_placeholder: "Fai una domanda",
  poll_options_label: "OPZIONI",
  poll_option: "Opzione",
  poll_add_option: "Aggiungi opzione",
  poll_allow_multiple: "Consenti più risposte",
  poll_multiple_allowed: "Seleziona una o più opzioni",
  poll_select_option: "Seleziona un'opzione",
  poll_view_votes: "Visualizza voti",
  poll_vote_singular: "voto",
  poll_vote_plural: "voti",
  poll_votes: "Voti del sondaggio",
  poll_no_votes_yet: "Ancora nessun voto",
  transcript_step_processing: "Trascrizione in corso...",
  ai_transcript_tab: "AI-Trascrizione",
  ai_transcript_info: "Disponibile solo per i messaggi vocali creati dopo il 09.03.2026.",
  no_transcript_available: "Nessuna trascrizione disponibile.",
  transcript_more: "...di più",
  transcript_less: "...meno",
  ki_transcript_voice_message: "KI-Trascrizione del messaggio vocale",
  ki_image_analysis: "Analisi immagine assistita da IA",
  type_message: "Scrivi un messaggio",
  email_tab_messages: "Messaggi",
  email_tab_email: "E-Mail",
  email_tab_messages_and_email: "Messages & E-Mail",
  email_tab_email_details: "E-Mail Details",
  email_accounts: "Account email",
  email_connect_gmail: "Connetti Gmail",
  email_connect_outlook: "Connetti Outlook",
  email_no_accounts: "Nessun account email connesso",
  email_no_accounts_hint: "Connetti un account email nelle impostazioni del profilo",
  email_no_messages: "Nessuna email",
  email_from: "Da",
  email_to: "A",
  email_subject: "Oggetto",
  email_disconnect: "Disconnetti",
  email_disconnect_confirm: "Sei sicuro di voler disconnettere questo account e-mail? Tutte le e-mail sincronizzate verranno rimosse.",
  email_account_disconnected: "Account e-mail disconnesso con successo",
  email_account_disconnect_failed: "Impossibile disconnettere l'account",
  email_connecting: "Connessione...",
  email_account_connected: "Account connesso con successo",
  email_connected_accounts: "Account connessi",
  email_sync_info: "Quando colleghi un account e-mail, le e-mail dell'ultimo mese vengono sincronizzate per impostazione predefinita. Puoi estendere il periodo di sincronizzazione qui sotto.",
  email_sync_3_months: "Sincronizza ultimi 3 mesi",
  email_sync_6_months: "Sincronizza ultimi 6 mesi",
  email_syncing: "Sincronizzazione...",
  email_sync_already_done: "{months} mesi già sincronizzati",
  email_sync_more: "Sincronizza altri mesi",
  email_sync_retry: "Risincronizza mesi",
  email_sync_all_done: "Tutti i mesi sincronizzati",
  email_sync_backfill_started: "Risincronizzazione e-mail precedenti — con caselle grandi può richiedere alcuni minuti…",
  email_sync_backfill_hint: "Recupera e-mail precedenti mancanti in questo periodo",
  email_sync_retry_3_months: "Risincronizza ultimi 3 mesi",
  email_sync_retry_6_months: "Risincronizza ultimi 6 mesi",
  email_syncing_account: "Sincronizzazione account in corso, potrebbe richiedere alcuni minuti…",
  email_signature: "Firma",
  email_signature_placeholder: "Inserisci la tua firma e-mail...",
  email_signature_save: "Salva",
  email_signature_saved: "Salvato",
  email_add_account: "Aggiungi account",
  email_folder_inbox: "Posta in arrivo",
  email_folder_spam: "Spam",
  email_folder_drafts: "Bozze",
  email_folder_sent: "Posta inviata",
  email_folder_deleted: "Posta eliminata",
  email_folder_archive: "Archivio",
  email_folder_outbox: "Posta in uscita",
  email_custom_folders: "Cartelle",
  email_create_folder: "Nuova cartella",
  email_delete_folder: "Elimina cartella",
  email_folder_name_placeholder: "Nome cartella",
  email_folder_created: "Cartella creata",
  email_folder_deleted: "Cartella eliminata",
  email_move_to: "Sposta in",
  email_moved_to_folder: "Spostato nella cartella",
  email_move_to_inbox: "Sposta nella posta in arrivo",
  email_confirm_delete_folder: "Sei sicuro di voler eliminare questa cartella?",
  email_refresh: "Aggiorna",
  email_go_to_settings: "Vai alle impostazioni",
  email_date: "Data",
  email_reply: "Rispondi",
  email_forward: "Inoltra",
  email_copy_text: "Copia testo",
  email_text_copied: "Copiato!",
  email_text_copy_failed: "Impossibile copiare il testo.",
  email_delete: "Elimina",
  email_not_spam: "Non è spam",
  email_not_spam_success: "Email spostata nella posta in arrivo.",
  email_not_spam_failed: "Impossibile spostare nella posta in arrivo.",
  email_delete_confirm: "Sei sicuro di voler eliminare questa e-mail?",
  email_delete_from_folder: "Sei sicuro di voler eliminare da {folder}?",
  email_delete_permanent_from_folder:
    "Sei sicuro di voler eliminare definitivamente da {folder}? Questa azione non può essere annullata.",
  email_save_draft_confirm: "Vuoi salvare questa e-mail come bozza?",
  email_save_draft: "Salva bozza",
  email_discard: "Elimina",
  email_back_to_compose: "Torna alla composizione",
  email_draft_saved: "Bozza salvata.",
  email_saving_draft: "Salvataggio bozza...",
  email_draft_save_failed: "Impossibile salvare la bozza.",
  email_loading: "Caricamento email...",
  email_imap_title: "IMAP",
  email_imap_hint: "Collega qualsiasi account e-mail tramite IMAP.",
  email_imap_user: "Email",
  email_imap_password: "Password",
  email_imap_connect_btn: "Collega account IMAP",
  email_imap_required: "Inserisci email e password.",
  email_imap_failed: "Connessione IMAP non riuscita.",
  email_imap_manual_toggle: "Impostazioni manuali del server",
  email_imap_host: "Server IMAP (es. imap.ionos.de)",
  email_imap_port: "Porta",
  email_imap_incoming: "Posta in arrivo (IMAP)",
  email_smtp_outgoing: "Posta in uscita (SMTP)",
  email_smtp_host: "Server SMTP (es. smtp.ionos.de)",
  email_smtp_port: "Porta",
  email_send_btn: "Invia",
  email_sent: "Email inviata.",
  email_sending: "Invio email in corso...",
  deleting_emails: "Eliminazione email...",
  marking_unread: "Contrassegnare come non letto...",
  email_send_failed: "Invio email non riuscito.",
  email_compose_to_required: "Il destinatario (A) è obbligatorio.",
  email_compose_body_required: "Inserisci un oggetto o un corpo del messaggio.",
  email_original_message: "Messaggio originale",
  email_forwarded_message: "Messaggio inoltrato",
  email_archived: "Archived",
  email_mark_spam: "Mark as spam",
  email_marked_spam: "Marked as spam",
  email_group_today: "Today",
  email_group_yesterday: "Yesterday",
  email_group_this_week: "This week",
  email_group_earlier: "Earlier",
  email_search: "Search",
  email_search_placeholder: "Search mail",
  email_no_results: "No matching messages",
  email_clear_search: "Clear search",
  email_star: "Star",
  email_unstar: "Unstar",
  email_starred: "Starred",
  email_folder_starred: "Starred",
  email_select: "Seleziona",
  email_attachment_singular: "Allegato",
  email_attachment_plural: "Allegati",
  email_back: "Indietro",
  email_download: "Scarica",
  email_close: "Chiudi",
  email_preview: "Anteprima",
  email_preview_not_available: "Anteprima non disponibile",
  email_preview_failed: "Anteprima non disponibile",
  select_attachments: "Seleziona allegati",
  email_loading_preview: "Caricamento anteprima...",
  email_mark_unread_failed: "e-mail non possono essere contrassegnate come non lette.",
  email_delete_failed: "e-mail non possono essere eliminate.",
  filter_all: "Tutti",
  filter_email: "E-Mail",
  filter_kjuup_messages: "Kjuup",
  filter_direct_messages: "Messaggi diretti",
  my_notes: "My Space",
  filter_internal_groups: "Chat di gruppo interne",
  filter_external_groups: "Chat di gruppo esterne",
  filter_group_chats: "Chat di gruppo",
  filter_groups_internal: "Interne",
  filter_groups_external: "Esterne",
  filter_unread_only: "Solo non letti",
  room_daily_briefing_info: "Se attivato, un report per questo progetto viene generato ogni 24 ore all'orario indicato nelle impostazioni personali — ma solo se in quel periodo c'è stata attività.",
  email_select_all: "Seleziona tutto",
  email_deselect_all: "Deseleziona tutto",
  email_reply_all: "Rispondi a tutti",
  email_reply_placeholder: "Scrivi la tua risposta...",
  email_forward_placeholder: "Aggiungi un messaggio...",
  email_edit_draft: "Modifica bozza",
  email_attach: "Allega",
  email_attachment_from_original: "Dal messaggio originale",
  email_remove: "Rimuovi",
  email_drop_files: "Trascina i file da allegare",
  email_loading_attachments: "Caricamento allegati...",
  email_archive: "Archivia",
  mark_unread: "Segna come non letto",
  mark_read: "Segna come letto",
  email_all_accounts: "Tutti gli account",
  email_error: "Errore",
  email_delete_email_failed: "Impossibile eliminare l'e-mail.",
  enter_url: "Inserisci URL",

  // ─── Kjuup subscription ───────────────────────────────────────────
  kjuup_io: 'Kjuup.io',
  kjuup_io_manage_subscription: 'Manage your subscription',
  kjuup_io_subscribe_now: 'Abbonati ora',
  kjuup_io_hero_subtitle: 'Upgrade to unlock premium features and get more out of every project.',
  kjuup_io_trial_badge: '1 MESE DI PROVA GRATUITA',
  kjuup_io_trial_title: 'Sblocca Kjuup.io Premium',
  kjuup_io_trial_subtitle: 'Collega la tua e-mail, ricevi suggerimenti di risposta basati sull\'IA e sincronizza automaticamente le attività con il calendario.',
  kjuup_io_trial_no_payment: 'No payment today.',
  kjuup_io_trial_trust: 'Nessun pagamento oggi. Non vengono richiesti i dati della carta di credito prima dell\'inizio dell\'abbonamento a pagamento.',
  kjuup_io_after_trial_monthly: 'After trial: {price}/month',
  kjuup_io_after_trial_yearly: 'After trial: {price}/year',
  kjuup_io_price_per_month: '{price}/month',
  kjuup_io_price_per_year: '{price}/year',
  kjuup_io_start_free_trial: 'Inizia gratis ora – senza rischi',
  kjuup_io_trial_footnote: 'No payment today. Then {price}. Cancel anytime.',
  kjuup_io_feature_email: 'Gestisci tutti gli account e-mail direttamente in Kjuup',
  kjuup_io_feature_assign: 'Assegna automaticamente e-mail e allegati ai progetti',
  kjuup_io_feature_ai: 'L\'IA scrive le risposte – tu confermi soltanto',
  kjuup_io_feature_tasks: 'Attività e calendario sempre aggiornati automaticamente',
  kjuup_io_choose_plan: 'Scegli il piano',
  kjuup_io_plan_monthly: 'Mensile',
  kjuup_io_plan_yearly: 'Annuale',
  kjuup_io_plan_monthly_desc: 'Billed monthly · cancel anytime',
  kjuup_io_plan_yearly_desc: 'Save {pct}% with annual booking',
  kjuup_io_save_badge: 'SAVE {pct}%',
  kjuup_io_per_month_annual: '{price} / month · Save {pct}% with annual booking',
  kjuup_io_subscribe: 'Subscribe',
  kjuup_io_secured_stripe: 'Protetto da Stripe · annulla quando vuoi',
  kjuup_io_your_subscription: 'YOUR SUBSCRIPTION',
  kjuup_io_status_active: 'ACTIVE',
  kjuup_io_status_cancels_soon: 'CANCELS SOON',
  kjuup_io_status_switch_scheduled: 'SWITCH SCHEDULED',
  kjuup_io_label_plan: 'Plan',
  kjuup_io_label_price: 'Price',
  kjuup_io_label_status: 'Status',
  kjuup_io_label_renews: 'Renews on',
  kjuup_io_label_access_until: 'Access until',
  kjuup_io_switching_to: 'Switching to {plan} on {date}',
  kjuup_io_cancel_pending_note: 'Your subscription is set to cancel and won\'t renew. You keep access until the date above.',
  kjuup_io_resume: 'Resume subscription',
  kjuup_io_switch_to_plan: 'Switch to {plan} plan',
  kjuup_io_undo_switch: 'Undo scheduled change',
  kjuup_io_cancel_subscription: 'Cancel subscription',
  kjuup_io_switch_modal_title: 'Switch to {plan} plan?',
  kjuup_io_billed_yearly: 'Billed yearly',
  kjuup_io_billed_monthly: 'Billed monthly',
  kjuup_io_switch_modal_note: 'Starts on {date}, when your current {plan} plan ends. No charge today — you keep your current plan until then.',
  kjuup_io_confirm_switch: 'Confirm switch',
  kjuup_io_not_now: 'Not now',
  kjuup_io_cancel_modal_title: 'Cancel subscription?',
  kjuup_io_cancel_modal_note: 'You\'ll keep access to Kjuup.io until the end of your current billing period. After that it won\'t renew.',
  kjuup_io_cancel_modal_note_with_date: 'You\'ll keep access to Kjuup.io until the end of your current billing period ({date}). After that it won\'t renew.',
  kjuup_io_cancel_plan: 'Cancel plan',
  kjuup_io_keep_subscription: 'Keep my subscription',
  kjuup_io_toast_payment_failed: 'Payment failed',
  kjuup_io_toast_activating: 'Pagamento ricevuto. Attivazione dell’abbonamento…',
  kjuup_io_toast_activating_soon: 'Pagamento ricevuto. L’abbonamento sarà attivato a breve.',
  kjuup_io_toast_cancel_period: 'Your subscription will cancel at the end of the period',
  kjuup_io_toast_cancel_fail: 'Unable to cancel subscription',
  kjuup_io_toast_switch_scheduled: 'You\'ll move to the {plan} plan when your current period ends',
  kjuup_io_toast_switch_fail: 'Unable to switch plan',
  kjuup_io_toast_resumed: 'Your subscription will keep renewing',
  kjuup_io_toast_resume_fail: 'Unable to resume subscription',
  kjuup_io_toast_undo: 'Scheduled plan change canceled',
  kjuup_io_toast_undo_fail: 'Unable to cancel the scheduled change',
  kjuup_io_email_locked_body: 'Email is part of Kjuup.io. Activate a plan to use the Email tab.',
  kjuup_io_connect_email: 'Connect email with Kjuup.io',
  kjuup_io_activate_to_connect_email: 'Activate Kjuup.io to connect email accounts',

  kjuup_io_trial_no_card: 'Non vengono richiesti i dati della carta di credito prima dell\'inizio dell\'abbonamento a pagamento.',
  kjuup_io_status_trialing: 'TRIAL',
  kjuup_io_trial_days_left: '{days} days left in your free trial',
  kjuup_io_trial_left_hours: '{count} ore rimanenti',
  kjuup_io_trial_left_hour: '1 ora rimanente',
  kjuup_io_trial_left_minutes: '{count} minuti rimanenti',
  kjuup_io_trial_left_minute: '1 minuto rimanente',
  kjuup_io_trial_left_seconds: '{count} secondi rimanenti',
  kjuup_io_trial_left_second: '1 secondo rimanente',
  kjuup_io_trial_ending_now: 'La tua prova sta terminando…',
  kjuup_io_request_timeout: 'Connessione scaduta. Riprova.',
  kjuup_io_info_days_free: '{days} giorni completamente gratis – l\'abbonamento inizia solo dopo la prova.',
  kjuup_io_discount_total: 'Il tuo sconto: {percent}%',
  kjuup_io_discount_company: '{company}: {percent}%',
  kjuup_io_discount_personal: 'Personale: {percent}%',
  kjuup_io_trial_ends_tomorrow: 'Your free trial ends tomorrow',
  kjuup_io_trial_ends_today: 'Your free trial ends today',
  kjuup_io_banner_dismiss: 'Chiudi',
  kjuup_io_billing_after_trial: 'You\'ll be charged after your trial ends on {date}.',
  kjuup_io_trial_ended_title: 'La tua prova gratuita è terminata',
  kjuup_io_trial_ended_body: 'Abbonati a Kjuup.io per continuare a usare l\'e-mail e le altre funzioni premium.',
  kjuup_io_subscribe_to_continue: 'Subscribe now to continue',
  kjuup_io_trial_active_title: 'You\'re on a free trial',
  kjuup_io_trial_active_subtitle: 'Choose a plan and subscribe — billing starts when your trial ends.',
  kjuup_io_toast_trial_started: 'La tua prova gratuita è iniziata',
  kjuup_io_toast_trial_fail: 'Impossibile avviare la prova gratuita',
  kjuup_io_trial_try_month: 'Prova Kjuup.io gratis per un mese.',
  kjuup_io_per_month: 'al mese',
  kjuup_io_price_month_line: '{price} / mese',
  kjuup_io_billed_annually_amount: '{price} fatturati annualmente',
  kjuup_io_save_yearly: 'Risparmia il {pct}% con la fatturazione annuale.',
  kjuup_io_save_amount_year: 'Risparmia {price} all\'anno',
  kjuup_io_savings_pct: '{pct}% di risparmio',
  kjuup_io_features_title: 'Cosa ottieni:',
  kjuup_io_info_one_month_free: 'Un mese gratis',
  kjuup_io_info_plan_after_trial: 'L\'abbonamento selezionato inizia dopo la prova.',
  kjuup_io_info_cancel_trial: 'Annulla in qualsiasi momento durante la prova.',
  kjuup_io_info_no_card: 'Nessuna carta di credito richiesta – inizia subito, senza inserire dati di pagamento.',
  kjuup_io_info_cancel_anytime: 'Annullabile in qualsiasi momento – nessun vincolo, nessun rischio.',
  kjuup_io_cta_plan_begins: 'Il piano selezionato inizia dopo la prova gratuita.',
  kjuup_io_billing_period_aria: 'Periodo di fatturazione',
  kjuup_io_subscription_info_title: 'Informazioni sull\'abbonamento',
  kjuup_io_first_payment_on: 'Primo pagamento il {date}.',
  kjuup_io_renews_on: 'Si rinnova il {date}.',
  kjuup_io_toast_card_saved: 'Metodo di pagamento salvato. L\'addebito avverrà al termine della prova.',
  calendar_sync_info: 'Sincronizza automaticamente tutti i ToDo di Kjuup con il tuo calendario.',
  calendar_no_accounts: 'Nessun calendario connesso.',
  article_new_badge: 'NUOVO',
  article_new_posts: '{0} nuovi post',
  documents: 'Documenti',
  add_documents: 'Aggiungi documenti',
  no_preview_available: 'Anteprima non disponibile',
  no_preview_hint: 'Questo tipo di file non può essere visualizzato in anteprima, ma verrà comunque inviato.',
  max_documents_reached: 'Puoi allegare fino a 10 documenti alla volta.',
  open_file: 'Apri file',
  twofa_title: 'Autenticazione a due fattori',
  twofa_method_totp: 'App di autenticazione',
  twofa_method_sms: 'SMS',
  twofa_method_email: 'Email',
  twofa_enter_app: 'Inserisci il codice a 6 cifre della tua app di autenticazione.',
  twofa_enter_sms: 'Inserisci il codice a 6 cifre che ti abbiamo inviato via SMS.',
  twofa_enter_email: 'Inserisci il codice a 6 cifre che ti abbiamo inviato via email.',
  twofa_resend: 'Invia di nuovo il codice',
  twofa_try_another: 'Prova un altro metodo',
  twofa_remember_device: 'Non chiedere di nuovo su questo dispositivo per 30 giorni',
  twofa_sent: 'Abbiamo inviato un codice.',
  twofa_invalid_code: 'Questo codice non è corretto. Riprova.',
  twofa_something_wrong: 'Qualcosa è andato storto. Riprova.',
  twofa_method_unavailable: 'Questo metodo non è disponibile.',
  twofa_on_desc: 'L\'autenticazione a due fattori è attiva. Ti servirà un codice a ogni accesso.',
  twofa_off_desc: 'Aggiungi un secondo passaggio dopo la password. Le app di autenticazione sono l\'opzione più sicura.',
  twofa_methods: 'Metodi',
  twofa_on: 'Attiva',
  twofa_add: 'Aggiungi',
  twofa_default_method: 'Metodo predefinito',
  twofa_default: 'Predefinito',
  twofa_turn_off: 'Disattiva',
  twofa_disable_hint: 'Inserisci la password e un codice attuale per disattivare l\'autenticazione a due fattori.',
  twofa_disable_need: 'Inserisci la password e un codice di verifica.',
  twofa_code_placeholder: 'Codice a 6 cifre o di backup',
  twofa_send_code: 'Invia un codice',
  twofa_primary_updated: 'Il metodo predefinito è stato aggiornato.',
  twofa_disabled: 'L\'autenticazione a due fattori è ora disattivata.',
  twofa_enabled: 'L\'autenticazione a due fattori è ora attiva.',
  twofa_totp_help: 'Scansiona questo QR code con Google Authenticator, Authy o 1Password. Puoi anche inserire la chiave manualmente.',
  twofa_secret_copied: 'Chiave copiata',
  twofa_sms_help: 'Inserisci il numero in formato internazionale. Ti invieremo un codice a 6 cifre via SMS.',
  twofa_email_help: 'Invieremo un codice a 6 cifre all\'email del tuo account.',
  twofa_backup_title: 'Codici di backup',
  twofa_backup_help: 'Conserva questi codici monouso in un posto sicuro. Ognuno vale una volta se perdi il telefono.',
  twofa_copy_codes: 'Copia i codici',
  twofa_codes_copied: 'Codici di backup copiati',
  twofa_regenerate: 'Ottieni nuovi codici di backup',
  twofa_regenerate_hint: 'Questo sostituisce i codici di backup non usati. Inserisci la password e un codice attuale.',
  twofa_backup_remaining: '{n} codici di backup non usati rimanenti',
  twofa_new_codes: 'Nuovi codici di backup',
  twofa_sms_unavailable: 'I codici via SMS non sono ancora disponibili.',
  todoist_sync_title: "Todoist",
  todoist_sync_info: "Le attività Kjuup a te assegnate vengono copiate in un progetto «Kjuup» nel tuo Todoist. Le modifiche in Todoist non vengono ricopiate.",
  todoist_connect: "Collega Todoist",
  todoist_connected: "Todoist collegato",
  todoist_connect_failed: "Connessione a Todoist non riuscita",
  todoist_disconnect: "Scollega",
  todoist_disconnected: "Todoist scollegato",
  todoist_disconnect_confirm: "Scollegare Todoist? Le attività già presenti in Todoist restano. La sincronizzazione si interrompe.",
  todoist_sync_now: "Sincronizza ora",
  todoist_syncing: "Sincronizzazione…",
  todoist_sync_done: "Sincronizzazione completata",
  todoist_sync_failed: "Sincronizzazione non riuscita",
  todoist_auth_error: "Ricollega Todoist per continuare la sincronizzazione.",
  todoist_last_sync: "Ultima sincronizzazione",
  todoist_not_connected: "Todoist non è collegato",
  todoist_auth_url_failed: "Impossibile aprire la pagina di autorizzazione di Todoist.",
  recommend_text: "Unisciti a Kjuup per restare in contatto e mantenere organizzata la tua comunicazione. Riunisci i tuoi canali, tieni i messaggi nei progetti giusti e inizia ogni mattina con un riepilogo e le tue attività – tutto sincronizzato con le app che usi già. Inizia gratis:",
  pro_auth_signin_title: 'Bentornato',
  pro_auth_signin_sub: 'Accedi con la tua e-mail di lavoro.',
  pro_auth_email_or_username: 'E-mail o nome utente',
  pro_auth_email_placeholder: 'nome@azienda.it',
  pro_auth_forgot_password: 'Password dimenticata?',
  pro_auth_create_account: 'Crea account',
  pro_auth_show_password: 'Mostra password',
  pro_auth_hide_password: 'Nascondi password',
  pro_auth_register_sub: 'Ti invieremo un link per confermare la tua e-mail.',
  pro_auth_register_plus_sub: 'Scegli un nome utente e una password. Poi imposti il tuo PIN di sicurezza.',
  pro_auth_check_credentials: 'Controlla e-mail e password',
  pro_news_export_pdf: 'Esporta come PDF',
  pro_news_pdf_failed: 'Impossibile creare il PDF.',
  pro_news_pdf_attachments: 'Allegati',
  pro_news_pdf_video: 'Video',
  pro_auth_forgot_sub: 'Inserisci la tua e-mail e ti invieremo un link per reimpostare la password.',
  pro_auth_send_link: 'Invia link di reimpostazione',
  pro_auth_plus_reset: 'Reimposta con PIN',
  pro_auth_show_pin: 'Mostra PIN',
  pro_auth_hide_pin: 'Nascondi PIN',
  v2_auth_plus_only: 'Solo Kjuup+',
  room_action_media: "File",
  room_tab_overview: "Panoramica",
  room_tab_history: "Cronologia",
  chat_info_media: "File",
  messages: "messaggi",
  pro_todo_project_required: "Scegli un progetto",
  pro_todo_choose_project: "Per quale progetto è questa attività?",
  cockpit_report_delete_confirm: "Eliminare questo report giornaliero?",
  cockpit_report_deleted: "Report giornaliero eliminato",
  cockpit_tab_company: "Azienda",
  cockpit_bookmarked_priorities: "Attività salvate",
  cockpit_load_error: "Impossibile caricare il cockpit.",
  cockpit_retry: "Riprova",
  cockpit_yesterday: "Ieri",
  cockpit_greeting_morning: "Buongiorno",
  cockpit_greeting_day: "Buon pomeriggio",
  cockpit_greeting_evening: "Buonasera",
  cockpit_assistant_q_open: "Cosa c'è di aperto oggi?",
  cockpit_assistant_q_summarize: "Riassumi la chat {{room}}",
  cockpit_assistant_q_overdue: "Quali attività sono scadute?",
  cockpit_assistant_new: "{{n}} nuovi",
  cockpit_assistant_important: "{{n}} importanti",
  cockpit_assistant_title: "Assistente Kjuup",
  cockpit_assistant_hint: "Tocca e chiedi",
  room_overview_priority_no_detail: "Il report non fornisce ulteriori dettagli su questa priorità.",
  room_overview_priority_from: "Fonte: {{name}}",
  room_overview_priority_open_task: "Apri attività",
  cockpit_priority_position: "{{index}} di {{total}} priorità",
  room_overview_today_title: "Importante oggi",
  room_overview_all_tasks: "Tutte",
  room_overview_tasks_empty: "Nessuna scadenza o attività aperta",
  room_overview_appointments_empty: "Nessun appuntamento in arrivo",
  room_overview_no_priorities: "Nessuna priorità aperta nell'ultimo report.",
  cockpit_report_top5: "Le 5 priorità principali",
  cockpit_report_todo_created: "Attività creata",
  cockpit_report_source_missing: "Impossibile trovare il messaggio di origine.",
  delete_bookmarked_priority_confirm: "Vuoi davvero eliminare questa attività salvata?",
  cockpit_report_create_todo: "Crea attività",
  cockpit_priorities_deleting: "Eliminazione in corso …",
  cockpit_priorities_select: "Elimina più elementi",
  cockpit_report_none: "Nessuna voce.",
  cockpit_priorities_delete_confirm: "Vuoi davvero eliminare {count} attività salvate?",
  cockpit_priorities_delete_failed: "Impossibile eliminare {count} attività",
  cockpit_priorities_deleted: "{count} attività eliminate",
  cockpit_priorities_selected: "{count} selezionate",
  cockpit_channel_connected: "Connesso",
  cockpit_channel_not_connected: "Non connesso",
  cockpit_channel_connect: "Collega",
  cockpit_channel_chat: "Chat Kjuup",
  cockpit_channel_active: "Attivo",
  cockpit_channel_hidden: "Nascosto",
  cockpit_channel_enable: "Attiva",
  cockpit_channel_email: "E-mail",
  cockpit_channel_check: "Verifica connessione",
  cockpit_channel_fix: "Verifica",
  cockpit_channel_forward: "Indirizzo di inoltro",
  cockpit_channel_not_set_up: "Non configurato",
  cockpit_channel_set_up: "Configura",
  cockpit_channel_teams: "Microsoft Teams",
  cockpit_channel_broken: "Connessione persa",
  cockpit_channel_importing: "Importazione",
  cockpit_channel_removing: "Disconnessione",
  cockpit_channel_reconnect: "Ricollega",
  cockpit_channels_title: "Canali",
  cockpit_company_role_super_admin: "Admin aziendale",
  cockpit_company_role_dept_admin: "Admin di reparto",
  cockpit_company_role_member: "Dipendente",
  cockpit_company_none: "Nessuna azienda Kjuup+ trovata",
  cockpit_company_eyebrow: "Azienda",
  cockpit_company_inactive: "inattiva",
  cockpit_company_settings: "Impostazioni aziendali",
  cockpit_company_employees: "Dipendenti",
  cockpit_company_internal_rooms: "Progetti interni",
  cockpit_report_all_projects: "Tutti i progetti",
  cockpit_report_progress_emails: "Analisi delle e-mail",
  cockpit_report_progress_chats: "Analisi dei messaggi di chat",
  cockpit_report_progress_documents: "Analisi di allegati e documenti",
  cockpit_report_progress_tasks: "Analisi delle attività",
  cockpit_report_progress_summarizing: "Analisi del contenuto",
  cockpit_report_progress_reading: "Riutilizzo dei contenuti già analizzati",
  cockpit_report_progress_collecting: "Raccolta di e-mail, chat e attività dei tuoi progetti",
  cockpit_report_progress_priorities: "Raccolta di priorità, scadenze e decisioni",
  cockpit_report_progress_queued: "Preparazione del report",
  cockpit_report_creating_title: "Il tuo report giornaliero è in preparazione",
  cockpit_report_progress_count_one: "1 elemento analizzato",
  cockpit_report_progress_count_many: "{{count}} elementi analizzati",
  cockpit_report_progress_hint: "Di solito ci vogliono uno o due minuti – nel frattempo puoi continuare a usare il cockpit.",
  cockpit_report_time_hint: "Il report giornaliero viene creato ogni giorno alle {{hour}}:00 per i cinque progetti più attivi.",
  room_overview_priorities_title: "Stato attuale e priorità",
  room_overview_as_of: "Aggiornato al {{time}}",
  cockpit_report_delete: "Elimina report giornaliero",
  email_tag_daily_briefing: "Report giornaliero",
  cockpit_report_unread: "Nuovo",
  cockpit_report_clear_project: "Mostra tutti i progetti",
  cockpit_filter_project: "Progetto",
  cockpit_filter_all_projects: "Tutti i progetti",
  cockpit_report_recreate: "Ricrea report giornaliero",
  cockpit_report_hide_previous: "Nascondi i report giornalieri precedenti",
  cockpit_report_show_previous: "Mostra i report giornalieri precedenti",
  cockpit_report_room_empty: "Nessun report giornaliero per questo progetto",
  cockpit_report_empty: "Nessun report giornaliero",
  cockpit_report_room_empty_hint: "Crea un report giornaliero solo per questo progetto.",
  cockpit_report_needs_mailbox: "Collega un account e-mail affinché Kjuup possa creare un report giornaliero con attività automatiche.",
  cockpit_report_create: "Crea report giornaliero",
  cockpit_email_connect: "Collega e-mail",
  cockpit_email_none_title: "Nessun account e-mail ancora collegato",
  cockpit_email_none_reports: "Collega la tua casella di posta affinché Kjuup possa assegnare le e-mail in arrivo ai tuoi progetti e creare report giornalieri con attività.",
  cockpit_email_none_client: "Collega Gmail, Outlook o IMAP per leggere, assegnare e rispondere alle e-mail direttamente in Kjuup.io.",
  cockpit_email_reports_title: "Client e-mail attuale",
  cockpit_email_reports_text: "Nessuna posta in arrivo in Kjuup.io · {{rooms}} progetti con report giornaliero alle {{hour}}:00 · le e-mail in arrivo vengono assegnate ai tuoi progetti.",
  cockpit_email_reports_rooms: "Gestisci progetti",
  cockpit_email_settings: "Impostazioni e-mail",
  cockpit_email_error_title: "Verifica connessione",
  cockpit_email_client_title: "Posta in arrivo collegata",
  cockpit_email_accounts_n: "{{n}} account collegato",
  cockpit_email_last_sync: "ultima sincronizzazione {{when}}",
  cockpit_email_report_at: "Report giornaliero alle {{hour}}:00",
  cockpit_email_open_inbox: "Apri posta in arrivo",
  cockpit_email_eyebrow: "Kjuup-E-mail",
  cockpit_email_accounts_label: "Indirizzi e-mail collegati",
  email_no_subject: "(Nessun oggetto)",
  cockpit_email_detail_loading: "Caricamento e-mail …",
  cockpit_email_detail_failed: "Impossibile caricare l'e-mail.",
  cockpit_email_detail_empty: "Questa e-mail non contiene testo.",
  cockpit_personal_settings: "Impostazioni personali",
  cockpit_companies: "Aziende",
  cockpit_title: "Cockpit",
  cockpit_back: "Torna alla panoramica",
  cockpit_day_overview: "La tua giornata in breve",
  email_saved_to_project: "E-mail salvata nel progetto",
  email_classify_need_project: "Inserisci un nome di progetto",
  cockpit_email_deleted: "E-mail eliminata",
  cockpit_email_sent_empty: "Nessuna e-mail inviata finora.",
  cockpit_email_incoming_empty: "Nessuna e-mail in arrivo finora.",
  cockpit_email_incoming_title: "E-mail",
  cockpit_email_incoming_sub: "Assegna le e-mail in arrivo e inviate ai tuoi progetti. Qui puoi modificare l'assegnazione.",
  cockpit_email_incoming_unassigned_n: "{{n}} non assegnate",
  cockpit_email_folder_inbox: "Posta in arrivo",
  cockpit_email_folder_sent: "Inviate",
  cockpit_email_open: "Apri e-mail",
  cockpit_email_incoming_suggested: "Suggerito: {{room}}",
  cockpit_email_incoming_apply: "Applica",
  cockpit_email_incoming_adjust: "Modifica assegnazione",
  cockpit_email_incoming_saving: "Salvataggio …",
  cockpit_email_incoming_unassigned: "Non assegnata",
  cockpit_email_incoming_show_less: "Mostra meno",
  cockpit_email_incoming_show_all: "Mostra tutte ({{n}})",
  cockpit_io_settings: "Impostazioni Kjuup.io",
  cockpit_io_settings_sub: "Piano e postazioni, assegnazione dei dipendenti, fatturazione e fatture.",
  products_coming_soon: "Prossimamente",
  cockpit_upsell_io_title: "Il tuo ufficio che pensa in anticipo",
  cockpit_upsell_io_text: "Collega i tuoi account e-mail a Kjuup. E-mail, allegati e messaggi vengono salvati automaticamente nel progetto corrispondente e, se vuoi, possono essere archiviati sul tuo server. Ogni giorno ricevi un riepilogo di tutti i progetti con i punti chiave di tutti i contenuti, e le tue attività si sincronizzano con il calendario o con l'app di to-do.",
  cockpit_upsell_io_soon_title: "Non ancora prenotabile",
  cockpit_upsell_io_soon_text: "Kjuup.io sarà presto disponibile. Richiedi subito informazioni – ti avviseremo non appena potrai prenotare Kjuup.io.",
  cockpit_upsell_io_planned_price: "Prezzo previsto",
  cockpit_upsell_io_cta_request: "Richiedi informazioni",
  kjuup_plus_abo_per_year: "/ anno",
  kjuup_plus_abo_per_month: "/ mese",
  kjuup_plus_abo_status_active: "Attivo",
  kjuup_plus_abo_status_requested: "Disdetta richiesta",
  kjuup_plus_abo_status_past_due: "Pagamento in scadenza",
  kjuup_plus_abo_eyebrow: "Kjuup+ · Abbonamento",
  kjuup_plus_abo_title: "Pacchetto Kjuup+",
  kjuup_plus_abo_seats_free_one: "1 postazione libera",
  kjuup_plus_abo_billing: "Fatturazione",
  kjuup_plus_abo_yearly: "Annuale",
  kjuup_plus_abo_monthly: "Mensile",
  kjuup_plus_abo_amount: "Importo",
  kjuup_plus_abo_ends: "Termina il",
  kjuup_plus_abo_renews: "Prossimo rinnovo",
  kjuup_plus_abo_next_invoice: "Prossima fattura",
  kjuup_plus_abo_intro: "Prezzo introduttivo",
  kjuup_plus_abo_pending_tier: "Dal prossimo rinnovo",
  kjuup_plus_abo_manual: "Kjuup+ è attivo per la tua azienda con un accordo individuale.",
  kjuup_plus_abo_invoices: "Fatture",
  kjuup_plus_abo_invoice_paid: "Pagata",
  kjuup_plus_abo_invoice_view: "Visualizza",
  kjuup_plus_abo_invoices_less: "Mostra meno",
  kjuup_plus_abo_member_hint: "Fatturazione e disdetta sono gestite dagli amministratori della tua azienda.",
  kjuup_plus_abo_withdraw: "Ritira la richiesta",
  kjuup_plus_abo_cancel_note: "Motivo (facoltativo)",
  kjuup_plus_abo_cancel_send: "Richiedi la disdetta",
  kjuup_plus_abo_cancel: "Disdici abbonamento",
  cockpit_upsell_plus_f1: "Gestisci l'attività di comunicazione di tutti i tuoi dipendenti",
  cockpit_upsell_plus_f2: "Informa gruppi di utenti specifici all'interno dell'azienda",
  cockpit_upsell_plus_f3: "Salva le chat di gruppo interne",
  cockpit_upsell_plus_when_yearly: "con pagamento annuale",
  cockpit_upsell_plus_size_small: "1–50 dipendenti",
  cockpit_upsell_plus_size_large: "51–200 dipendenti",
  cockpit_upsell_plus_title: "Kjuup+ per le aziende",
  cockpit_upsell_plus_text: "Gestisci dipendenti, permessi di scrittura e comunicazione aziendale in un unico posto. I canali interni restano nel tuo team, i canali esterni ti collegano ai partner di progetto e puoi raggiungere direttamente gruppi specifici. Oltre a Kjuup+, puoi prenotare l'accesso a Kjuup.io per gruppi di dipendenti. Kjuup+ e Kjuup.io possono essere combinati.",
  cockpit_upsell_plus_size: "Dimensione dell'azienda",
  cockpit_upsell_plus_billing: "Fatturazione",
  cockpit_upsell_plus_per_company: "/ azienda · mese IVA esclusa",
  cockpit_upsell_plus_onboarding: "I costi di onboarding/avviamento dipendono dalle dimensioni dell'azienda",
  cockpit_upsell_plus_larger: "Prezzi per aziende più grandi su richiesta",
  cockpit_upsell_plus_cta: "Richiesta senza impegno",
  cockpit_kpi_deadlines_tasks: "Scadenze e attività",
  cockpit_kpi_appointments: "Appuntamenti",
  cockpit_room_admin: "Gestione progetti e chat",
  cockpit_room_admin_sub: "Tutti i progetti aziendali con membri, media e chat.",
  pro_todo_not_found: "Questa attività non è più disponibile.",
  cockpit_chip_overdue: "Scaduta",
  cockpit_chip_today: "Oggi",
  cockpit_calendar_week: "Sett. {{week}}",
  cockpit_prev_week: "Settimana precedente",
  cockpit_next_week: "Settimana successiva",
  cockpit_chip_requested: "Richiesta",
  cockpit_todo_due: "Scadenza {{when}}",
  cockpit_todo_at: "{{time}}",
  cockpit_todo_requested_from: "da {{name}}",
  cockpit_todo_since: "da {{when}}",
  cockpit_todo_no_date: "Senza data",
  cockpit_todo_mark_done: "Segna come completata",
  cockpit_my_tasks_title: "Le mie attività",
  cockpit_today_tasks_group: "Attività di oggi",
  cockpit_assign_none: "Nessuno assegnato",
  no_project_found: "Nessun progetto trovato",
  cockpit_row_more_actions: "Altre azioni",
  needs_date: "Assegna data",
  cockpit_assign_proposal: "{{name}} riconosciuto – assegnare?",
  cockpit_assign_proposal_confirm: "Assegna",
  cockpit_assign_proposal_dismiss: "Ignora",
  cockpit_priority_date: "Data",
  todo_calendar_add: "Aggiungi al calendario",
  todo_calendar_remove: "Rimuovi dal calendario",
  cockpit_todo_change_project: "Cambia progetto",
  cockpit_todo_set_date: "Imposta data",
  pro_todo_done_confirm: "Vuoi davvero segnare questa attività come completata?",
  cockpit_task_delete_failed: "Impossibile eliminare l'attività.",
  cockpit_setup_title: "Completa la configurazione",
  cockpit_setup_text: "Decidi se vuoi usare le chat e se Kjuup.io deve funzionare come client e-mail o solo con progetti e report giornalieri.",
  cockpit_setup_cta: "Configura ora",
  cockpit_group_tasks: "Scadenze e attività",
  cockpit_group_appointments: "Appuntamenti",
  cockpit_report_no_activity: "Questo progetto non ha ricevuto nuovi messaggi o e-mail nelle ultime 24 ore.",
  cockpit_report_room_unavailable: "Questo progetto non è disponibile.",
  cockpit_report_create_failed: "Impossibile creare il report giornaliero.",
  cockpit_report_created: "Report giornaliero creato",
  addon_enable_confirm: "Attivare il componente aggiuntivo?",
  addon_enable: "Attiva",
  addon_enabled: "Componente aggiuntivo attivato",
  nav_email: "E-mail",
  nav_my_cockpit: "Il mio cockpit",
  nav_news: "Novità",
  nav_recommend: "Consiglia",
  pro_todo_status_done: "Completata",
  pro_todo_status_open: "Aperta",
  v2_todo_remove: "Rimuovi",
  pro_todo_search_people: "Cerca persone",
  pro_todo_clear: "Cancella",
  pro_todo_assigned: "(assegnato)",
  pro_todo_no_people: "Nessuna persona trovata",
  pro_todo_search_rooms: "Cerca progetti",
  pro_todo_no_rooms_match: "Nessun progetto corrisponde a “{{q}}”",
  pro_todo_no_rooms: "Nessun progetto trovato",
  pro_todo_activity: "Attività",
  pro_todo_show_less: "Mostra meno",
  pro_todo_show_all: "Mostra tutto ({{n}})",
  pro_todo_due: "Scadenza",
  pro_todo_room: "Progetto",
  pro_todo_select_room: "Seleziona progetto",
  pro_todo_status: "Stato",
  pro_todo_more: "Altro",
  pro_todo_edit_title: "Modifica attività",
  pro_todo_description: "Descrizione",
  pro_todo_created_by: "Creata da",
  pro_todo_chat: "Chat",
  navigate_to_source: "Vai all'origine",
  todo_calendar_connect_title: "Nessun calendario collegato",
  todo_calendar_connect_body_web: "Collega un calendario nelle impostazioni di sincronizzazione del calendario per aggiungervi le attività.",
  todo_calendar_connect: "Collega",
  todo_calendar_removed: "Rimosso dal tuo calendario",
  todo_calendar_added_later: "Aggiunto. Impossibile raggiungere il tuo calendario; Kjuup riproverà più tardi.",
  todo_calendar_added: "Aggiunto al tuo calendario",
  todo_calendar_no_date: "Solo un'attività con una data può essere aggiunta a un calendario.",
  todo_calendar_failed: "Impossibile aggiornare il tuo calendario. Riprova.",
  todo_calendar_date_title: "Ancora nessuna data",
  todo_calendar_date_save: "Imposta data e aggiungi",
  todo_calendar_date_body_web: "Questa attività salvata non ha ancora una data. Impostane una per aggiungerla al tuo calendario.",
  kjuup_io_setup_saved: "Configurazione salvata",
  kjuup_io_setup_step: "Passaggio",
  kjuup_io_setup_chats_title: "Vuoi usare le chat?",
  kjuup_io_setup_email_title: "Dove vuoi leggere le tue e-mail?",
  kjuup_io_setup_chats_sub: "Le chat con colleghi e partner di progetto sono facoltative. Puoi mostrarle o nasconderle in qualsiasi momento nel cockpit.",
  kjuup_io_setup_email_sub: "Qui scegli solo se usare un client e-mail in Kjuup o continuare con il tuo programma di posta attuale, come Outlook o un altro. Potrai cambiare in seguito.",
  kjuup_io_setup_chats_yes: "Sì, mostra le chat",
  kjuup_io_setup_chats_yes_text: "Messaggi contiene chat ed e-mail. I progetti hanno chat di gruppo per tutti i partecipanti.",
  kjuup_io_setup_chats_no: "No, lavora senza chat",
  kjuup_io_setup_chats_no_text: "Le chat sono nascoste. “Messaggi” diventa “E-mail”; progetti, attività e report giornalieri restano.",
  kjuup_io_setup_email_client: "Client e-mail in Kjuup",
  kjuup_io_setup_email_client_text: "Leggi e rispondi alle e-mail direttamente in Kjuup.",
  kjuup_io_setup_email_reports: "Client e-mail attuale",
  kjuup_io_setup_email_reports_text: "Continua a leggere e rispondere nel tuo programma attuale, come Outlook o un altro.",
  kjuup_io_setup_skip: "Più tardi",
  next: "Avanti",
  kjuup_io_setup_finish: "Completa la configurazione",
  today_label: "oggi",
  tomorrow_label: "domani",
  cockpit_todo_overdue: "scaduta",
  cockpit_report_management_fazit: "Sintesi per il management",
  cockpit_todo_appointment: "Appuntamento",
  cockpit_todo_deadline: "Scadenza",
  cockpit_todo_deadline_define: "Imposta scadenza",
  pro_todo_status_acknowledged: "Confermata",
  pro_todo_responsible: "Responsabile",
  pro_todo_notice_confirmed: "Confermato in chat",
  pro_todo_notice_sent_at: "Messaggio inviato",
  pro_todo_notice_again: "Invia di nuovo il messaggio",
  pro_todo_notice_send: "Informa tramite messaggio Kjuup",
  pro_todo_add_assignee: "Aggiungi",
  pro_todo_edit: "Modifica",
  pro_todo_change_room: "Cambia progetto",
  pro_todo_due_on: "Scadenza il",
  pro_todo_edit_due: "Modifica scadenza",
  pro_todo_no_date: "Senza data",
  pro_todo_edit_description: "Modifica descrizione",
  pro_todo_no_description: "Nessuna descrizione",
  pro_todo_title_label: "Titolo",
  pro_todo_title_placeholder: "Inserisci un titolo...",
  pro_todo_task: "Attività",
  pro_todo_what: "Cosa bisogna fare?",
  pro_todo_source_email: "E-mail",
  pro_todo_sources: "Fonti",
  previous: "Precedente",
  kjuup_plus_abo_tier_large: "Kjuup+ Large (fino a {max} dipendenti)",
  kjuup_plus_abo_tier_small: "Kjuup+ Small (fino a {max} dipendenti)",
  kjuup_plus_abo_status_ends: "Termina il {date}",
  kjuup_plus_abo_seats_over: "Più di {max} dipendenti – Kjuup ti contatterà con un'offerta personalizzata.",
  kjuup_plus_abo_seats_next: "Se si aggiungono altri dipendenti, il pacchetto passa automaticamente a {next} (calcolo pro rata).",
  kjuup_plus_abo_seats_used: "{used} postazioni su {total} occupate",
  kjuup_plus_abo_seats_free: "Ancora {count} postazioni libere",
  kjuup_plus_abo_intro_until: "fino al {date}",
  kjuup_plus_abo_invoice_open: "Aperta · scadenza {date}",
  kjuup_plus_abo_invoices_all: "Mostra tutte ({count})",
  kjuup_plus_abo_requested_hint: "Disdetta richiesta il {date}. Kjuup la conferma alla fine del periodo contrattuale ({end}).",
  kjuup_plus_abo_cancel_hint: "Kjuup esamina la tua richiesta e conferma la disdetta alla fine del periodo contrattuale ({end}). Fino ad allora Kjuup+ resta attivo.",
  kjuup_plus_abo_withdrawn: "Richiesta di disdetta ritirata",
  kjuup_plus_abo_requested: "Disdetta richiesta",
  cockpit_upsell_plus_intro_hint: "primi {months} mesi, poi {price}",
  cockpit_upsell_plus_badge: "PREZZO DI LANCIO PER {months} MESI",
  calendar_syncing: "Aggiornamento dal calendario…",
  calendar_sync_up_to_date: "Il calendario è già aggiornato",
  calendar_sync_failed: "Sincronizzazione non riuscita",
  todo_created_from_message: "Attività creata da questo messaggio",
  kjuup_io_todo_calendar_trial_ended_note: "Sincronizzazione calendario · Abbonati",
  kjuup_io_todo_calendar_nudge: "Sincronizzare questo ToDo con il tuo calendario?",
  kjuup_io_todo_calendar_nudge_cta: "Attiva Kjuup.io",
  todo_confirmed: "ToDo confermato",
  pro_todo_bulk_delete_title: "Eliminare {{n}} attività?",
  pro_todo_previous_none_own: "Le attività scadute ti sono state assegnate da altri e solo loro possono eliminarle.",
  pro_todo_previous_none: "Nessuna attività scaduta",
  pro_todo_previous_title: "Eliminare {{n}} attività scadute?",
  pro_todo_previous_text: "Tutte le tue attività aperte dei giorni precedenti verranno eliminate.",
  pro_todo_previous_skipped: "{{n}} assegnate da altri restano.",
  unassign_task_confirm: "Vuoi annullare la tua assegnazione a questa attività?",
  pro_todo_delete_title: "Elimina attività",
  pro_todo_today: "Oggi",
  pro_todo_yesterday: "Ieri",
  pro_todo_since_yesterday: "Da ieri",
  pro_todo_mark_open: "Segna come aperta",
  new_label: "Nuovo",
  bookmarked_no_mylist: "Le attività nei segnalibri non possono essere aggiunte a La mia lista",
  pro_todo_of_completed: "{{done}} di {{total}} completate",
  pro_todo_pick_date: "Scegli una data",
  pro_todo_show_day: "Mostra giorno",
  pro_todo_section_upcoming: "In arrivo",
  pro_todo_section_done: "Completate",
  pro_todo_room_empty_today: "Nessuna attività oggi in questo progetto",
  pro_todo_room_empty_day: "Nessuna attività in questo giorno in questo progetto",
  pro_todo_delete_previous: "Elimina tutte",
  pro_todo_empty_title: "Niente qui",
  pro_todo_empty_hint: "Nessuna attività corrisponde a questa vista.",
  pro_todo_selected: "{{n}} selezionate",
  pro_todo_adjust_done: "Fatto",
  pro_todo_deleting: "Eliminazione...",
  pro_todo_reopen: "Riapri attività",
  pro_todo_step_done: "Completata",
  pro_todo_mark_not_started: "Segna come non iniziata",
  pro_todo_mark_in_progress: "Segna come in corso",
  pro_todo_open_room: "Apri progetto",
  pro_todo_new_task: "Nuova attività",
  select_user_back_to_in_progress: "Seleziona l'utente da rimettere in corso",
  cockpit_email_accounts_n_many: "{{n}} account collegati",
  // Kjuup + Microsoft Teams chats (new-chat pickers, combined groups)
  combined_tab_kjuup: "Contatti Kjuup",
  combined_tab_teams: "Contatti Teams",
  combined_bridge_failed: "Non è stato possibile creare la copia Teams.",
  combined_chat_label: "Kjuup + Teams",
  combined_guest_tag: "Teams",
  combined_new_group_note: "Contatti Kjuup e Teams: viene creato un nuovo gruppo che appare anche in Microsoft Teams.",
  teams_new_chat_title: "Nuova chat Teams",
  teams_new_chat_topic: "Nome del gruppo (facoltativo)",
  teams_new_chat_start: "Avvia chat",
  teams_new_chat_creating: "Creazione della chat…",
  teams_new_chat_forbidden: "Microsoft Teams non consente questa chat (ad es. una persona esterna alla tua organizzazione o una regola del tuo reparto IT).",
  teams_new_chat_too_many: "Troppe persone per una chat.",
  teams_new_chat_type_hint: "Digita un nome per cercare nella tua organizzazione.",
  teams_new_chat_directory_forbidden: "La tua organizzazione non consente la ricerca nella directory. Vengono mostrate solo le persone delle tue chat Teams.",
  teams_new_chat_account: "Account",
};
